import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.scenario.sets');
import { OnDestroy, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";


@Component({
    selector: 'wiz-page-scenario-sets',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.scenario.sets/view.scss */
:host {
  min-width: 0;
  container: page-scenario-sets/inline-size;
  display: block;
  min-height: 100%;
  background: var(--wb-page-canvas, #f5f9fd);
}

.scenario-page-icon {
  display: inline-flex;
  width: 2.75rem;
  height: 2.75rem;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border-radius: 1rem;
  background: #ecfeff;
  color: #0f766e;
}

.scenario-header-stats {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}
.scenario-header-stats span {
  display: inline-flex;
  align-items: baseline;
  gap: 0.25rem;
  border: 1px solid #e2e8f0;
  border-radius: 9999px;
  background: #f8fafc;
  padding: 0.45rem 0.7rem;
  font-size: 0.6875rem;
  font-weight: 700;
  color: #64748b;
}
.scenario-header-stats strong {
  color: #0f172a;
  font-size: 0.8125rem;
}

.scenario-filter-panel {
  border: 1px solid #e2e8f0;
  border-radius: 1rem;
  background: #fff;
  padding: 0.75rem;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.scenario-search-input {
  width: 100%;
  min-height: 2.625rem;
  border: 1px solid #cbd5e1;
  border-radius: 0.75rem;
  background: #fff;
  padding: 0.625rem 0.875rem 0.625rem 2.4rem;
  color: #0f172a;
  font-size: 0.75rem;
  outline: none;
}
.scenario-search-input::placeholder {
  color: #94a3b8;
}
.scenario-search-input:focus {
  border-color: #0d9488;
  box-shadow: 0 0 0 3px rgba(13, 148, 136, 0.12);
}

.scenario-category-list {
  display: flex;
  min-width: 0;
  flex: 1 1 auto;
  gap: 0.4rem;
  overflow-x: auto;
  padding-bottom: 0.1rem;
}

.scenario-category-chip {
  display: inline-flex;
  min-height: 2.5rem;
  flex: 0 0 auto;
  align-items: center;
  gap: 0.4rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.75rem;
  background: #f8fafc;
  padding: 0.55rem 0.7rem;
  color: #475569;
  font-size: 0.6875rem;
  font-weight: 700;
  transition: border-color 150ms ease, background-color 150ms ease, color 150ms ease;
}
.scenario-category-chip small {
  display: inline-flex;
  min-width: 1.15rem;
  height: 1.15rem;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  background: #e2e8f0;
  padding: 0 0.3rem;
  color: #64748b;
  font-size: 0.6rem;
}
.scenario-category-chip:hover {
  border-color: #99f6e4;
  background: #f0fdfa;
  color: #0f766e;
}
.scenario-category-chip.is-active {
  border-color: #0f766e;
  background: #0f766e;
  color: #fff;
  box-shadow: 0 2px 5px rgba(15, 118, 110, 0.18);
}
.scenario-category-chip.is-active small {
  background: rgba(255, 255, 255, 0.18);
  color: #fff;
}

.scenario-workspace {
  display: grid;
  align-items: start;
  gap: 1rem;
  margin-top: 1rem;
}

.scenario-list-panel,
.scenario-detail-panel {
  overflow: hidden;
  border: 1px solid #e2e8f0;
  border-radius: 1rem;
  background: #fff;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.05);
}

.scenario-list-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  border-bottom: 1px solid #e2e8f0;
  padding: 1rem;
}
.scenario-list-header.is-raw {
  border-top: 1px solid #e2e8f0;
  background: #f8fafc;
}
.scenario-list-header.is-raw.is-only-list {
  border-top: 0;
}

.scenario-result-count {
  display: inline-flex;
  min-width: 2.5rem;
  justify-content: center;
  border-radius: 9999px;
  background: #ecfeff;
  padding: 0.35rem 0.6rem;
  color: #0f766e;
  font-size: 0.6875rem;
  font-weight: 800;
}
.scenario-result-count.is-raw {
  background: #eef2ff;
  color: #4338ca;
}

.scenario-list {
  display: grid;
  max-height: 22rem;
  gap: 0.4rem;
  overflow-y: auto;
  padding: 0.5rem;
}
.scenario-list.is-raw.is-only-list {
  max-height: clamp(22rem, 100vh - 18rem, 52rem);
}

.scenario-list-item {
  position: relative;
  display: flex;
  width: 100%;
  align-items: flex-start;
  gap: 0.65rem;
  overflow: hidden;
  border: 1px solid transparent;
  border-radius: 0.8rem;
  background: #fff;
  padding: 0.8rem 0.75rem 0.8rem 0.9rem;
  transition: border-color 150ms ease, background-color 150ms ease, box-shadow 150ms ease;
}
.scenario-list-item:hover {
  border-color: #cbd5e1;
  background: #f8fafc;
}
.scenario-list-item.is-selected {
  border-color: #99f6e4;
  background: #f0fdfa;
  box-shadow: 0 0 0 2px rgba(13, 148, 136, 0.07);
}
.scenario-list-item.is-selected .scenario-id {
  color: #0f766e;
}
.scenario-list-item.is-raw.is-completed:not(.is-selected) {
  border-color: #86efac;
  background: #f0fdf4;
  box-shadow: 0 0 0 2px rgba(22, 163, 74, 0.08);
}
.scenario-list-item.is-raw.is-completed:not(.is-selected) .scenario-id {
  color: #15803d;
}
.scenario-list-item.is-raw.is-completed:not(.is-selected):hover {
  border-color: #4ade80;
  background: #dcfce7;
}
.scenario-list-item.is-raw.is-selected {
  border-color: #c7d2fe;
  background: #eef2ff;
  box-shadow: 0 0 0 2px rgba(79, 70, 229, 0.07);
}
.scenario-list-item.is-raw.is-selected .scenario-id {
  color: #4338ca;
}

.scenario-id {
  color: #334155;
  font-size: 0.6875rem;
  letter-spacing: 0.04em;
}

.scenario-mini-tag {
  max-width: 8.5rem;
  overflow: hidden;
  border-radius: 9999px;
  background: #f1f5f9;
  padding: 0.2rem 0.45rem;
  color: #64748b;
  font-size: 0.6rem;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.scenario-mini-tag.is-turn-count {
  background: #eef2ff;
  color: #4338ca;
}
.scenario-mini-tag.is-completed {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  background: #dcfce7;
  color: #166534;
  font-weight: 800;
}

.scenario-detail-header {
  border-bottom: 1px solid #e2e8f0;
  padding: 1.25rem;
}

.scenario-detail-id,
.scenario-detail-category,
.scenario-detail-period,
.scenario-detail-profile,
.scenario-detail-count,
.scenario-detail-origin,
.scenario-detail-completed {
  display: inline-flex;
  align-items: center;
  border-radius: 9999px;
  padding: 0.3rem 0.6rem;
  font-size: 0.6875rem;
  font-weight: 800;
}

.scenario-detail-completed {
  gap: 0.3rem;
  border: 1px solid #86efac;
  background: #f0fdf4;
  color: #166534;
}

.scenario-detail-id {
  background: #0f766e;
  color: #fff;
  letter-spacing: 0.04em;
}

.scenario-detail-category {
  background: #ecfeff;
  color: #0f766e;
}

.scenario-detail-profile {
  background: #f5f3ff;
  color: #6d28d9;
}

.scenario-detail-period {
  background: #fff7ed;
  color: #c2410c;
}

.scenario-detail-count {
  background: #f1f5f9;
  color: #475569;
}

.scenario-detail-origin {
  border: 1px solid #c7d2fe;
  background: #eef2ff;
  color: #4338ca;
  letter-spacing: 0.06em;
}

.scenario-phase-summary {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.4rem;
  min-width: 17rem;
}
.scenario-phase-summary span {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid #e2e8f0;
  border-radius: 0.7rem;
  background: #f8fafc;
  padding: 0.5rem;
  color: #64748b;
  font-size: 0.6rem;
  font-weight: 700;
}
.scenario-phase-summary strong {
  color: #0f172a;
  font-size: 0.95rem;
}
.scenario-phase-summary .is-memory {
  border-color: #fde68a;
  background: #fffbeb;
}
.scenario-phase-summary .is-memory strong {
  color: #b45309;
}

.scenario-detail-actions {
  display: grid;
  width: min(100%, 23rem);
  flex: 0 0 auto;
  gap: 0.65rem;
}

.scenario-export-actions {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.45rem;
}

.scenario-export-button {
  display: inline-flex;
  min-height: 2.35rem;
  align-items: center;
  justify-content: center;
  gap: 0.45rem;
  border: 1px solid #cbd5e1;
  border-radius: 0.7rem;
  background: #fff;
  padding: 0.5rem 0.7rem;
  color: #334155;
  font-size: 0.6875rem;
  font-weight: 800;
  transition: border-color 150ms ease, background 150ms ease, color 150ms ease;
}
.scenario-export-button:hover:not(:disabled) {
  border-color: #0d9488;
  background: #f0fdfa;
  color: #0f766e;
}
.scenario-export-button:focus-visible {
  outline: 3px solid rgba(13, 148, 136, 0.2);
  outline-offset: 2px;
}
.scenario-export-button:disabled {
  cursor: wait;
  opacity: 0.6;
}

.scenario-basis {
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px dashed #e2e8f0;
}

.scenario-basis-heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
}
.scenario-basis-heading > div {
  display: flex;
  min-width: 0;
  align-items: flex-start;
  gap: 0.7rem;
}
.scenario-basis-heading h3 {
  color: #0f172a;
  font-size: 0.9375rem;
  font-weight: 800;
}
.scenario-basis-heading p {
  margin-top: 0.2rem;
  color: #64748b;
  font-size: 0.8125rem;
  line-height: 1.55;
}

.scenario-basis-heading-icon {
  display: inline-flex;
  width: 2.25rem;
  height: 2.25rem;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border-radius: 0.7rem;
  background: #e6fffb;
  color: #0f766e;
  font-size: 0.8rem;
}

.scenario-basis-count {
  display: inline-flex;
  min-height: 2rem;
  flex: 0 0 auto;
  align-items: center;
  border: 1px solid #cbd5e1;
  border-radius: 9999px;
  background: #fff;
  padding: 0.35rem 0.65rem;
  color: #475569;
  font-size: 0.75rem;
  font-weight: 800;
}

.scenario-basis-groups {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.75rem;
  margin-top: 0.85rem;
}

.scenario-basis-group {
  min-width: 0;
  overflow: hidden;
  border: 1px solid #dbe4ee;
  border-radius: 0.8rem;
  background: #fff;
}
.scenario-basis-group > header {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  border-bottom: 1px solid #e2e8f0;
  background: #f8fafc;
  padding: 0.65rem 0.75rem;
}
.scenario-basis-group > header h4 {
  color: #1e293b;
  font-size: 0.875rem;
  font-weight: 800;
}
.scenario-basis-group > header p {
  margin-top: 0.1rem;
  color: #64748b;
  font-size: 0.75rem;
  line-height: 1.4;
}
.scenario-basis-group dl {
  padding: 0.15rem 0.75rem;
}
.scenario-basis-group dl > div {
  display: grid;
  grid-template-columns: 5.5rem minmax(0, 1fr);
  align-items: start;
  gap: 0.75rem;
  min-width: 0;
  padding: 0.6rem 0;
}
.scenario-basis-group dl > div + div {
  border-top: 1px solid #f1f5f9;
}
.scenario-basis-group dt {
  color: #64748b;
  font-size: 0.75rem;
  font-weight: 800;
}
.scenario-basis-group dd {
  color: #1e293b;
  font-size: 0.875rem;
  font-weight: 700;
  line-height: 1.55;
  word-break: keep-all;
  overflow-wrap: anywhere;
}
.scenario-basis-group.is-dialogue {
  grid-column: 1/-1;
}
.scenario-basis-group.is-dialogue > header {
  background: #f0f9ff;
}
.scenario-basis-group.is-dialogue .scenario-basis-group-icon {
  background: #dbeafe;
  color: #1d4ed8;
}
.scenario-basis-group.is-person > header {
  background: #faf5ff;
}
.scenario-basis-group.is-person .scenario-basis-group-icon {
  background: #f3e8ff;
  color: #7e22ce;
}

.scenario-basis-group-icon {
  display: inline-flex;
  width: 2rem;
  height: 2rem;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border-radius: 0.6rem;
  background: #ccfbf1;
  color: #0f766e;
  font-size: 0.75rem;
}

.raw-design-notes {
  margin: 1rem;
  overflow: hidden;
  border: 1px solid #c7d2fe;
  border-radius: 1rem;
  background: #f8fafc;
}

.raw-design-notes-header {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  border-bottom: 1px solid #e0e7ff;
  background: #eef2ff;
  padding: 1rem 1.125rem;
}
.raw-design-notes-header h3 {
  color: #1e1b4b;
  font-size: 0.9375rem;
  font-weight: 800;
}
.raw-design-notes-header p {
  margin-top: 0.25rem;
  color: #64748b;
  font-size: 0.8125rem;
  line-height: 1.55;
}

.raw-design-notes-icon {
  display: inline-flex;
  width: 2.25rem;
  height: 2.25rem;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border-radius: 0.7rem;
  background: #fff;
  color: #4338ca;
  font-size: 0.8rem;
}

.raw-source-note {
  margin: 0.85rem 0.85rem 0;
  border: 1px solid #e2e8f0;
  border-radius: 0.75rem;
  background: #fff;
  padding: 0.8rem 0.9rem;
  color: #334155;
  font-size: 0.8125rem;
  line-height: 1.7;
  word-break: keep-all;
}

.raw-design-note-grid {
  display: grid;
  gap: 0.65rem;
  padding: 0.85rem;
}
.raw-design-note-grid article {
  display: flex;
  min-width: 0;
  align-items: flex-start;
  gap: 0.65rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.75rem;
  background: #fff;
  padding: 0.75rem;
}
.raw-design-note-grid article > span {
  display: inline-flex;
  width: 1.85rem;
  height: 1.85rem;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border-radius: 0.55rem;
  background: #eef2ff;
  color: #4338ca;
  font-size: 0.6875rem;
}
.raw-design-note-grid article h4 {
  color: #334155;
  font-size: 0.75rem;
  font-weight: 800;
}
.raw-design-note-grid article p {
  margin-top: 0.25rem;
  color: #475569;
  font-size: 0.8125rem;
  line-height: 1.65;
  word-break: keep-all;
}

.scenario-extraction {
  margin: 1rem;
  border: 1px solid #dbe4ee;
  border-radius: 1rem;
  background: #f6f8fb;
  overflow: hidden;
}

.scenario-extraction-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  border-bottom: 1px solid #e2e8f0;
  background: #fff;
  padding: 1rem 1.125rem;
}
.scenario-extraction-header h3 {
  color: #0f172a;
  font-size: 0.9375rem;
  font-weight: 800;
}
.scenario-extraction-header p {
  margin-top: 0.3rem;
  color: #64748b;
  font-size: 0.8125rem;
  line-height: 1.6;
}

.scenario-extraction-heading {
  display: flex;
  min-width: 0;
  align-items: flex-start;
  gap: 0.75rem;
}

.scenario-extraction-heading-icon {
  display: inline-flex;
  width: 2.25rem;
  height: 2.25rem;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border-radius: 0.7rem;
  background: #e6fffb;
  color: #0f766e;
  font-size: 0.8rem;
}

.scenario-extraction-method {
  display: inline-flex;
  min-height: 2rem;
  flex: 0 0 auto;
  align-items: center;
  gap: 0.35rem;
  border: 1px solid #99f6e4;
  border-radius: 9999px;
  background: #f0fdfa;
  padding: 0.35rem 0.65rem;
  color: #0f766e;
  font-size: 0.75rem;
  font-weight: 800;
}

.scenario-extraction-grid {
  display: grid;
  gap: 1rem;
  padding: 1rem;
}

.scenario-extraction-card {
  min-width: 0;
  overflow: hidden;
  border: 1px solid #bae6fd;
  border-radius: 0.875rem;
  background: #fff;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}
.scenario-extraction-card > header {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  border-bottom: 1px solid #bae6fd;
  background: #f0f9ff;
  padding: 0.8rem 0.9rem;
  color: #0369a1;
}
.scenario-extraction-card > header > div {
  min-width: 0;
  flex: 1 1 auto;
}
.scenario-extraction-card > header strong {
  display: block;
  color: #0c4a6e;
  font-size: 0.875rem;
  font-weight: 800;
}
.scenario-extraction-card > header small {
  display: block;
  margin-top: 0.15rem;
  color: #64748b;
  font-size: 0.75rem;
  line-height: 1.4;
}
.scenario-extraction-card.is-positive {
  border-color: #fde68a;
}
.scenario-extraction-card.is-positive > header {
  border-color: #fde68a;
  background: #fffbeb;
}
.scenario-extraction-card.is-positive > header strong {
  color: #92400e;
}
.scenario-extraction-card.is-positive .scenario-extraction-card-icon,
.scenario-extraction-card.is-positive .scenario-extraction-index {
  background: #fef3c7;
  color: #b45309;
}
.scenario-extraction-card.is-positive .scenario-extraction-count,
.scenario-extraction-card.is-positive .scenario-extraction-meta span {
  border-color: #fde68a;
  background: #fffbeb;
  color: #a16207;
}

.scenario-extraction-card-icon {
  display: inline-flex;
  width: 2rem;
  height: 2rem;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border-radius: 0.65rem;
  background: #dbeafe;
  color: #0369a1;
  font-size: 0.75rem;
}

.scenario-extraction-count {
  display: inline-flex;
  min-width: 2.4rem;
  height: 1.7rem;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border: 1px solid #bae6fd;
  border-radius: 9999px;
  background: #fff;
  padding: 0 0.5rem;
  color: #0369a1;
  font-size: 0.75rem;
  font-weight: 800;
}

.scenario-extraction-list {
  display: grid;
  gap: 0.65rem;
  padding: 0.75rem;
}

.scenario-extraction-item {
  display: grid;
  grid-template-columns: 2rem minmax(0, 1fr);
  align-items: start;
  gap: 0.7rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.75rem;
  background: #fff;
  padding: 0.75rem;
}
.scenario-extraction-item + .scenario-extraction-item {
  margin-top: 0;
}

.scenario-extraction-index {
  display: inline-flex;
  width: 2rem;
  height: 2rem;
  align-items: center;
  justify-content: center;
  border-radius: 0.65rem;
  background: #e0f2fe;
  color: #0369a1;
  font-size: 0.75rem;
  font-weight: 900;
}

.scenario-extraction-content {
  min-width: 0;
}

.scenario-extraction-meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
}
.scenario-extraction-meta strong {
  color: #1e293b;
  font-size: 0.875rem;
  font-weight: 800;
}
.scenario-extraction-meta span {
  display: inline-flex;
  min-height: 1.65rem;
  flex: 0 0 auto;
  align-items: center;
  gap: 0.3rem;
  border: 1px solid #bae6fd;
  border-radius: 9999px;
  background: #f0f9ff;
  padding: 0.25rem 0.5rem;
  color: #0369a1;
  font-size: 0.75rem;
  font-weight: 750;
}

.scenario-extraction-content > p {
  margin-top: 0.55rem;
  color: #334155;
  font-size: 0.875rem;
  line-height: 1.75;
  word-break: keep-all;
  overflow-wrap: anywhere;
}

.scenario-content-studio {
  margin: 1rem;
  overflow: hidden;
  border: 1px solid #cbd5e1;
  border-radius: 0.9rem;
  background: #f8fafc;
}

.scenario-content-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  border-bottom: 1px solid #e2e8f0;
  background: #fff;
  padding: 1rem;
}

.scenario-content-icon {
  display: inline-flex;
  width: 2.25rem;
  height: 2.25rem;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border-radius: 0.7rem;
  background: #ccfbf1;
  color: #0f766e;
  font-size: 0.75rem;
}

.scenario-review-badge {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  border-radius: 9999px;
  background: #fef3c7;
  padding: 0.3rem 0.6rem;
  color: #92400e;
  font-size: 0.625rem;
  font-weight: 800;
}

.scenario-content-grid {
  display: grid;
  gap: 0.85rem;
  padding: 0.85rem;
}

.scenario-content-bundle {
  min-width: 0;
  overflow: hidden;
  border: 1px solid #bae6fd;
  border-radius: 0.85rem;
  background: #fff;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.035);
}
.scenario-content-bundle.is-positive {
  border-color: #fde68a;
}
.scenario-content-bundle.is-positive .scenario-bundle-header {
  background: #fffbeb;
  color: #b45309;
}
.scenario-content-bundle.is-positive .scenario-bundle-kind {
  background: #fef3c7;
  color: #92400e;
}
.scenario-content-bundle.is-positive .scenario-excerpt-list li.is-patient {
  border-color: #bbf7d0;
  background: #f0fdf4;
}
.scenario-content-bundle.is-positive .scenario-media-tabs button.is-active,
.scenario-content-bundle.is-positive .scenario-copy-button {
  border-color: #d97706;
  background: #d97706;
}

.scenario-bundle-header {
  display: flex;
  min-height: 5rem;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  border-bottom: 1px solid #e2e8f0;
  background: #f0f9ff;
  padding: 0.85rem 1rem;
  color: #0369a1;
}
.scenario-bundle-header > i {
  margin-top: 0.15rem;
}

.scenario-bundle-kind,
.scenario-bundle-source {
  display: inline-flex;
  align-items: center;
  border-radius: 9999px;
  padding: 0.2rem 0.5rem;
  font-size: 0.6rem;
  font-weight: 800;
}

.scenario-bundle-kind {
  background: #dbeafe;
  color: #1d4ed8;
}

.scenario-bundle-source {
  background: rgba(255, 255, 255, 0.8);
  color: #64748b;
}

.scenario-excerpt,
.scenario-prompt-panel {
  padding: 0.9rem;
}

.scenario-prompt-panel {
  border-top: 1px solid #e2e8f0;
  background: #f8fafc;
}

.scenario-subtitle-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  color: #64748b;
  font-size: 0.625rem;
}
.scenario-subtitle-row strong {
  color: #334155;
  font-size: 0.6875rem;
}

.scenario-excerpt-list {
  display: grid;
  gap: 0.4rem;
  margin-top: 0.65rem;
}
.scenario-excerpt-list li {
  border: 1px solid #e2e8f0;
  border-radius: 0.65rem;
  background: #f8fafc;
  padding: 0.55rem 0.65rem;
}
.scenario-excerpt-list li.is-patient {
  border-color: #bae6fd;
  background: #f0f9ff;
}
.scenario-excerpt-list li p {
  margin-top: 0.2rem;
  color: #334155;
  font-size: 0.6875rem;
  line-height: 1.55;
}

.scenario-excerpt-speaker {
  display: block;
  color: #64748b;
  font-size: 0.6rem;
  font-weight: 800;
}

.scenario-media-tabs {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.35rem;
  margin-top: 0.65rem;
  padding: 0.25rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.7rem;
  background: #fff;
}
.scenario-media-tabs button {
  display: inline-flex;
  min-height: 2.25rem;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
  border: 1px solid transparent;
  border-radius: 0.55rem;
  color: #64748b;
  font-size: 0.65rem;
  font-weight: 800;
  transition: background-color 140ms ease, border-color 140ms ease, color 140ms ease;
}
.scenario-media-tabs button:hover {
  background: #f1f5f9;
  color: #334155;
}
.scenario-media-tabs button.is-active {
  border-color: #0f766e;
  background: #0f766e;
  color: #fff;
}

.scenario-prompt-copy {
  margin-top: 0.65rem;
}

.scenario-prompt-text,
.scenario-negative-prompt {
  border: 1px solid #e2e8f0;
  background: #fff;
  padding: 0.7rem;
}
.scenario-prompt-text p,
.scenario-negative-prompt p {
  margin-top: 0.35rem;
  color: #334155;
  font-size: 0.6875rem;
  line-height: 1.6;
  white-space: pre-wrap;
}

.scenario-prompt-text {
  border-radius: 0.7rem 0.7rem 0 0;
}

.scenario-negative-prompt {
  border-top: 0;
  border-radius: 0 0 0.7rem 0.7rem;
  background: #fff7ed;
}
.scenario-negative-prompt strong,
.scenario-negative-prompt p {
  color: #9a3412;
}
.scenario-negative-prompt strong {
  font-size: 0.625rem;
}

.scenario-prompt-label {
  color: #0f766e;
  font-size: 0.625rem;
  font-weight: 800;
}

.scenario-copy-button {
  display: inline-flex;
  min-height: 2.25rem;
  width: 100%;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  margin-top: 0.55rem;
  border: 1px solid #0f766e;
  border-radius: 0.65rem;
  background: #0f766e;
  color: #fff;
  font-size: 0.6875rem;
  font-weight: 800;
  transition: background-color 140ms ease, border-color 140ms ease;
}
.scenario-copy-button:hover {
  border-color: #115e59;
  background: #115e59;
}

.scenario-transcript {
  padding: 1rem;
}

.scenario-phase {
  overflow: hidden;
  border: 1px solid #e2e8f0;
  border-radius: 0.9rem;
}
.scenario-phase + .scenario-phase {
  margin-top: 1rem;
}

.scenario-phase-header {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  border-bottom: 1px solid #e2e8f0;
  background: #f8fafc;
  padding: 0.8rem 1rem;
}

.scenario-phase-icon {
  display: inline-flex;
  width: 2rem;
  height: 2rem;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border-radius: 0.65rem;
  background: #e0f2fe;
  color: #0369a1;
  font-size: 0.75rem;
}

.scenario-phase-range {
  border-radius: 9999px;
  background: #e2e8f0;
  padding: 0.15rem 0.5rem;
  color: #475569;
  font-size: 0.625rem;
  font-weight: 800;
}

.phase-positive_memory {
  border-color: #fde68a;
}
.phase-positive_memory .scenario-phase-header {
  border-color: #fde68a;
  background: #fffbeb;
}
.phase-positive_memory .scenario-phase-icon {
  background: #fef3c7;
  color: #b45309;
}
.phase-positive_memory .scenario-phase-range {
  background: #fde68a;
  color: #92400e;
}

.phase-care_plan {
  border-color: #bbf7d0;
}
.phase-care_plan .scenario-phase-header {
  border-color: #bbf7d0;
  background: #f0fdf4;
}
.phase-care_plan .scenario-phase-icon {
  background: #dcfce7;
  color: #15803d;
}

.phase-raw_dialogue {
  border-color: #c7d2fe;
}
.phase-raw_dialogue .scenario-phase-header {
  border-color: #e0e7ff;
  background: #eef2ff;
}
.phase-raw_dialogue .scenario-phase-icon {
  background: #fff;
  color: #4338ca;
}
.phase-raw_dialogue .scenario-phase-range {
  background: #e0e7ff;
  color: #3730a3;
}

.scenario-dialogue-list {
  display: grid;
  gap: 0.85rem;
  background: #fff;
  padding: 1.25rem clamp(1rem, 3vw, 2.5rem);
}

.scenario-turn {
  display: flex;
  width: 100%;
  align-items: flex-start;
  justify-content: flex-start;
}
.scenario-turn.is-patient {
  justify-content: flex-end;
}
.scenario-turn.is-patient .scenario-bubble {
  border-color: #e2e8f0;
  border-bottom-left-radius: 1rem;
  border-bottom-right-radius: 0.35rem;
  background: #f8fafc;
}
.scenario-turn.is-patient .scenario-speaker {
  color: #475569;
}
.scenario-turn.is-patient .scenario-purpose {
  background: #e2e8f0;
  color: #475569;
}

.scenario-bubble {
  width: fit-content;
  max-width: min(82%, 50rem);
  border: 1px solid #bae6fd;
  border-radius: 1rem 1rem 1rem 0.35rem;
  background: #f0f9ff;
  padding: 0.7rem 0.85rem 0.75rem;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.035);
}
.scenario-bubble p {
  color: #1e293b;
  font-size: 0.8125rem;
  line-height: 1.65;
}

.scenario-bubble-meta {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0.5rem;
  margin-bottom: 0.35rem;
  color: #94a3b8;
  font-size: 0.625rem;
  font-weight: 700;
}

.scenario-speaker {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  color: #0369a1;
  font-size: 0.6875rem;
  font-weight: 800;
}

.scenario-turn-number {
  border-left: 1px solid #cbd5e1;
  padding-left: 0.55rem;
}

.scenario-purpose {
  display: inline-flex;
  margin-top: 0.55rem;
  border-radius: 9999px;
  background: #dbeafe;
  padding: 0.2rem 0.45rem;
  color: #1d4ed8;
  font-size: 0.6rem;
  font-weight: 700;
}

.raw-turn-metadata {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
  margin-top: 0.55rem;
}
.raw-turn-metadata .scenario-purpose {
  margin-top: 0;
}
.raw-turn-metadata .scenario-signal {
  background: #fef3c7;
  color: #92400e;
}

.phase-positive_memory .scenario-bubble {
  border-color: #fde68a;
  background: #fffdf5;
}
.phase-positive_memory .scenario-speaker {
  color: #b45309;
}
.phase-positive_memory .scenario-purpose {
  background: #fef3c7;
  color: #92400e;
}
.phase-positive_memory .scenario-turn.is-patient .scenario-bubble {
  border-color: #d1fae5;
  background: #f0fdf4;
}

.scenario-detail-footer {
  display: flex;
  align-items: flex-start;
  gap: 0.65rem;
  border-top: 1px solid #e2e8f0;
  background: #f8fafc;
  padding: 0.85rem 1.25rem;
  color: #64748b;
  font-size: 0.6875rem;
  line-height: 1.55;
}
.scenario-detail-footer i {
  margin-top: 0.1rem;
  color: #0f766e;
}

.scenario-raw-actions {
  display: grid;
  width: 100%;
  flex: 0 0 auto;
  gap: 0.65rem;
}

.scenario-followup-trigger {
  display: grid;
  grid-template-columns: 2.35rem minmax(0, 1fr) auto auto;
  align-items: center;
  gap: 0.7rem;
  width: 100%;
  min-height: 3.65rem;
  border: 1px solid #c7d2fe;
  border-radius: 0.85rem;
  background: #eef2ff;
  padding: 0.65rem 0.75rem;
  color: #312e81;
  text-align: left;
  transition: border-color 150ms ease, background 150ms ease, box-shadow 150ms ease, transform 150ms ease;
}
.scenario-followup-trigger:hover {
  border-color: #818cf8;
  background: #e0e7ff;
  box-shadow: 0 5px 16px rgba(79, 70, 229, 0.12);
  transform: translateY(-1px);
}
.scenario-followup-trigger:focus-visible {
  outline: 3px solid rgba(99, 102, 241, 0.24);
  outline-offset: 2px;
}

.scenario-followup-trigger-icon {
  display: inline-flex;
  width: 2.35rem;
  height: 2.35rem;
  align-items: center;
  justify-content: center;
  border-radius: 0.7rem;
  background: #fff;
  color: #4f46e5;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);
}

.scenario-followup-trigger-copy {
  display: grid;
  min-width: 0;
  gap: 0.1rem;
}
.scenario-followup-trigger-copy small {
  color: #6366f1;
  font-size: 0.625rem;
  font-weight: 800;
}
.scenario-followup-trigger-copy strong {
  overflow: hidden;
  color: #312e81;
  font-size: 0.8125rem;
  font-weight: 850;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.scenario-followup-trigger-score {
  display: inline-flex;
  min-width: 2.25rem;
  height: 2.25rem;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  background: #fef3c7;
  color: #92400e;
  font-size: 0.75rem;
  font-weight: 900;
}
.scenario-followup-trigger-score.is-ready {
  background: #dcfce7;
  color: #166534;
}

.scenario-followup-trigger-arrow {
  color: #818cf8;
  font-size: 0.6875rem;
}

.scenario-drawer-backdrop {
  position: fixed;
  z-index: 70;
  inset: 0;
  width: 100%;
  height: 100%;
  border: 0;
  background: rgba(15, 23, 42, 0.48);
  cursor: default;
  animation: scenario-backdrop-in 180ms ease-out;
}

.scenario-question-drawer {
  position: fixed;
  z-index: 80;
  top: 0;
  right: 0;
  bottom: 0;
  display: grid;
  grid-template-rows: auto minmax(0, 1fr) auto;
  width: min(48rem, 100vw - 1rem);
  overflow: hidden;
  border-left: 1px solid #cbd5e1;
  background: #f8fafc;
  box-shadow: -18px 0 48px rgba(15, 23, 42, 0.2);
  animation: scenario-drawer-in 220ms cubic-bezier(0.22, 1, 0.36, 1);
}

.scenario-drawer-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  border-bottom: 1px solid #e2e8f0;
  background: #fff;
  padding: 1.15rem 1.25rem 1rem;
}
.scenario-drawer-header h2 {
  margin-top: 0.35rem;
  color: #0f172a;
  font-size: 1.25rem;
  font-weight: 900;
  letter-spacing: -0.025em;
}
.scenario-drawer-header p {
  margin-top: 0.2rem;
  overflow: hidden;
  color: #64748b;
  font-size: 0.75rem;
  font-weight: 650;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.scenario-drawer-eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  color: #4f46e5;
  font-size: 0.6875rem;
  font-weight: 850;
}

.scenario-drawer-close {
  display: inline-flex;
  width: 2.5rem;
  height: 2.5rem;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border: 1px solid #e2e8f0;
  border-radius: 0.75rem;
  background: #fff;
  color: #475569;
  transition: background 150ms ease, color 150ms ease, border-color 150ms ease;
}
.scenario-drawer-close:hover {
  border-color: #cbd5e1;
  background: #f8fafc;
  color: #0f172a;
}
.scenario-drawer-close:focus-visible {
  outline: 3px solid rgba(20, 184, 166, 0.24);
  outline-offset: 2px;
}

.scenario-drawer-scroll {
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
  padding: 1rem 1.1rem 2rem;
}

.scenario-completion-banner {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 0.75rem;
  border: 1px solid #86efac;
  border-radius: 0.95rem;
  background: #f0fdf4;
  padding: 0.8rem 0.9rem;
}
.scenario-completion-banner > span {
  display: inline-flex;
  width: 2rem;
  height: 2rem;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  background: #dcfce7;
  color: #15803d;
}
.scenario-completion-banner strong {
  color: #14532d;
  font-size: 0.75rem;
  font-weight: 900;
}
.scenario-completion-banner p {
  margin-top: 0.15rem;
  color: #166534;
  font-size: 0.625rem;
  line-height: 1.5;
}
.scenario-completion-banner b {
  color: #15803d;
  font-size: 1rem;
  font-weight: 950;
}

.scenario-question-drawer.is-media-generation {
  background: #fff;
}
.scenario-question-drawer.is-media-generation .scenario-drawer-scroll {
  padding: 1.25rem 1.35rem 2.5rem;
}

.scenario-content-scope {
  margin-bottom: 1rem;
  border: 1px solid #c7d2fe;
  border-radius: 0.9rem;
  background: #f8faff;
  padding: 1rem;
}
.scenario-content-scope strong {
  color: #312e81;
  font-size: 0.8125rem;
  font-weight: 900;
}
.scenario-content-scope p {
  margin-top: 0.45rem;
  color: #334155;
  font-size: 0.75rem;
  line-height: 1.65;
}
.scenario-content-scope small {
  display: block;
  margin-top: 0.7rem;
  color: #64748b;
  font-size: 0.6875rem;
  line-height: 1.55;
}

.scenario-generation-summary {
  overflow: hidden;
  border: 1px solid #99f6e4;
  border-radius: 0.9rem;
  background: #f8fffd;
}
.scenario-generation-summary > summary {
  display: flex;
  min-height: 4rem;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.9rem 1rem;
  cursor: pointer;
  list-style: none;
  color: #134e4a;
}
.scenario-generation-summary > summary::-webkit-details-marker {
  display: none;
}
.scenario-generation-summary > summary > span {
  display: inline-flex;
  align-items: center;
  gap: 0.55rem;
}
.scenario-generation-summary > summary > span:first-child i {
  color: #0d9488;
}
.scenario-generation-summary > summary strong {
  color: #134e4a;
  font-size: 0.8125rem;
  font-weight: 900;
}
.scenario-generation-summary > summary b {
  color: #0f766e;
  font-size: 0.75rem;
  font-weight: 900;
}
.scenario-generation-summary > summary .fa-chevron-down {
  font-size: 0.6875rem;
  transition: transform 160ms ease;
}
.scenario-generation-summary > summary:focus-visible {
  outline: 3px solid rgba(20, 184, 166, 0.2);
  outline-offset: -3px;
}
.scenario-generation-summary[open] > summary .fa-chevron-down {
  transform: rotate(180deg);
}

.scenario-generation-summary + .scenario-generation-summary {
  margin-top: 1rem;
}

.scenario-generation-summary-body {
  border-top: 1px solid #ccfbf1;
  background: #fff;
  padding: 0.9rem 1rem 1rem;
}
.scenario-generation-summary-body > p {
  color: #64748b;
  font-size: 0.6875rem;
  line-height: 1.6;
}
.scenario-generation-summary-body dl {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.65rem 1rem;
  margin-top: 0.75rem;
}
.scenario-generation-summary-body dl > div {
  display: grid;
  gap: 0.18rem;
  border-top: 1px solid #f1f5f9;
  padding-top: 0.55rem;
}
.scenario-generation-summary-body dt {
  color: #0f766e;
  font-size: 0.625rem;
  font-weight: 850;
}
.scenario-generation-summary-body dd {
  color: #475569;
  font-size: 0.6875rem;
  line-height: 1.55;
}

.scenario-generation-readiness {
  margin-top: 0.75rem;
  border: 1px solid #c7d2fe;
  border-radius: 0.9rem;
  background: #f8faff;
  padding: 0.85rem 1rem;
}
.scenario-generation-readiness header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
}
.scenario-generation-readiness header > div {
  display: flex;
  align-items: baseline;
  gap: 0.25rem;
}
.scenario-generation-readiness header span {
  margin-right: 0.35rem;
  color: #475569;
  font-size: 0.6875rem;
  font-weight: 850;
}
.scenario-generation-readiness header strong {
  color: #3730a3;
  font-size: 1.25rem;
  font-weight: 950;
}
.scenario-generation-readiness header small {
  color: #64748b;
  font-size: 0.6875rem;
  font-weight: 750;
}
.scenario-generation-readiness header b {
  border-radius: 9999px;
  background: #fef3c7;
  padding: 0.3rem 0.55rem;
  color: #92400e;
  font-size: 0.625rem;
  font-weight: 900;
}
.scenario-generation-readiness > p {
  margin-top: 0.55rem;
  color: #64748b;
  font-size: 0.6875rem;
  line-height: 1.55;
}
.scenario-generation-readiness.is-ready {
  border-color: #86efac;
  background: #f0fdf4;
}
.scenario-generation-readiness.is-ready header strong,
.scenario-generation-readiness.is-ready header b {
  color: #166534;
}
.scenario-generation-readiness.is-ready header b {
  background: #dcfce7;
}
.scenario-generation-readiness.is-denied {
  border-color: #cbd5e1;
  background: #f8fafc;
}
.scenario-generation-readiness.is-denied header strong,
.scenario-generation-readiness.is-denied header b {
  color: #475569;
}
.scenario-generation-readiness.is-denied header b {
  background: #e2e8f0;
}

.scenario-generation-readiness-track {
  height: 0.45rem;
  margin-top: 0.65rem;
  overflow: hidden;
  border-radius: 9999px;
  background: #e2e8f0;
}
.scenario-generation-readiness-track span {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: linear-gradient(90deg, #14b8a6, #4f46e5);
  transition: width 200ms ease;
}
.is-ready .scenario-generation-readiness-track span {
  background: #16a34a;
}
.is-denied .scenario-generation-readiness-track span {
  background: #94a3b8;
}

.scenario-score-card {
  border: 1px solid #c7d2fe;
  border-radius: 1rem;
  background: #fff;
  padding: 1rem;
  box-shadow: 0 2px 8px rgba(79, 70, 229, 0.06);
}

.scenario-score-heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
}

.scenario-score-label {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  color: #4338ca;
  font-size: 0.6875rem;
  font-weight: 850;
}

.scenario-score-value {
  display: flex;
  align-items: baseline;
  gap: 0.3rem;
  margin-top: 0.1rem;
}
.scenario-score-value strong {
  color: #1e1b4b;
  font-size: 2rem;
  font-weight: 950;
  letter-spacing: -0.05em;
  line-height: 1.05;
}
.scenario-score-value span {
  color: #64748b;
  font-size: 0.75rem;
  font-weight: 700;
}

.scenario-score-target {
  display: inline-flex;
  align-items: center;
  border-radius: 9999px;
  background: #fef3c7;
  padding: 0.35rem 0.65rem;
  color: #92400e;
  font-size: 0.6875rem;
  font-weight: 850;
}
.scenario-score-target.is-ready {
  background: #dcfce7;
  color: #166534;
}

.scenario-score-track {
  height: 0.5rem;
  margin-top: 0.8rem;
  overflow: hidden;
  border-radius: 9999px;
  background: #e2e8f0;
}
.scenario-score-track span {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: linear-gradient(90deg, #14b8a6, #4f46e5);
  transition: width 240ms ease;
}

.scenario-score-breakdown {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.5rem;
  margin-top: 0.9rem;
}
.scenario-score-breakdown > span {
  display: grid;
  gap: 0.2rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.7rem;
  background: #f8fafc;
  padding: 0.6rem;
}
.scenario-score-breakdown small {
  color: #64748b;
  font-size: 0.625rem;
  font-weight: 700;
}
.scenario-score-breakdown strong {
  color: #1e293b;
  font-size: 0.75rem;
  font-weight: 850;
}

.scenario-score-caption {
  margin-top: 0.7rem;
  color: #64748b;
  font-size: 0.6875rem;
  line-height: 1.55;
}

.scenario-missing-card {
  display: flex;
  align-items: flex-start;
  gap: 0.7rem;
  margin-top: 0.75rem;
  border: 1px solid #ddd6fe;
  border-radius: 0.85rem;
  background: #f5f3ff;
  padding: 0.85rem;
}
.scenario-missing-card h3 {
  color: #312e81;
  font-size: 0.75rem;
  font-weight: 850;
}
.scenario-missing-card p {
  margin-top: 0.3rem;
  color: #4338ca;
  font-size: 0.75rem;
  line-height: 1.55;
}
.scenario-missing-card small {
  display: block;
  margin-top: 0.45rem;
  color: #6d28d9;
  font-size: 0.625rem;
  font-weight: 750;
}
.scenario-missing-card.is-completed {
  border-color: #bbf7d0;
  background: #f0fdf4;
}
.scenario-missing-card.is-completed h3,
.scenario-missing-card.is-completed p,
.scenario-missing-card.is-completed small {
  color: #166534;
}
.scenario-missing-card.is-completed .scenario-missing-icon {
  background: #dcfce7;
  color: #15803d;
}

.scenario-missing-icon {
  display: inline-flex;
  width: 2rem;
  height: 2rem;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border-radius: 0.65rem;
  background: #ede9fe;
  color: #6d28d9;
  font-size: 0.75rem;
}

.scenario-rubric-card {
  margin-top: 0.75rem;
  overflow: hidden;
  border: 1px solid #cbd5e1;
  border-radius: 0.95rem;
  background: #fff;
}
.scenario-rubric-card > header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  border-bottom: 1px solid #e2e8f0;
  padding: 0.85rem 0.9rem;
}
.scenario-rubric-card > header h3 {
  color: #0f172a;
  font-size: 0.8125rem;
  font-weight: 900;
}
.scenario-rubric-card > header p {
  margin-top: 0.2rem;
  color: #64748b;
  font-size: 0.6875rem;
  line-height: 1.5;
}
.scenario-rubric-card > header > span {
  flex: 0 0 auto;
  border-radius: 9999px;
  background: #eef2ff;
  padding: 0.25rem 0.5rem;
  color: #4338ca;
  font-size: 0.5625rem;
  font-weight: 850;
}

.scenario-rubric-legend {
  display: grid;
  gap: 0.25rem;
  border-bottom: 1px solid #e2e8f0;
  background: #f8fafc;
  padding: 0.65rem 0.9rem;
  color: #64748b;
  font-size: 0.625rem;
  font-weight: 700;
  line-height: 1.45;
}

.scenario-domain-item + .scenario-domain-item {
  border-top: 1px solid #e2e8f0;
}
.scenario-domain-item > summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  cursor: pointer;
  padding: 0.75rem 0.9rem;
  list-style-position: inside;
}
.scenario-domain-item > summary > span:first-child {
  display: inline-flex;
  min-width: 0;
  align-items: baseline;
  gap: 0.45rem;
}
.scenario-domain-item > summary strong {
  color: #1e293b;
  font-size: 0.75rem;
  font-weight: 850;
}
.scenario-domain-item > summary small {
  color: #94a3b8;
  font-size: 0.5625rem;
  font-weight: 700;
}
.scenario-domain-item > summary:hover {
  background: #f8fafc;
}
.scenario-domain-item[open] > summary {
  background: #f8fafc;
}

.scenario-domain-score {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 0.35rem;
  border-radius: 9999px;
  background: #fff7ed;
  padding: 0.25rem 0.5rem;
}
.scenario-domain-score strong {
  color: #9a3412 !important;
  font-size: 0.6875rem !important;
}
.scenario-domain-score small {
  color: #c2410c !important;
}
.scenario-domain-score.is-complete {
  background: #ecfdf5;
}
.scenario-domain-score.is-complete strong {
  color: #166534 !important;
}

.scenario-domain-body {
  border-top: 1px solid #e2e8f0;
  padding: 0.75rem 0.9rem 0.9rem;
}

.scenario-domain-description {
  color: #64748b;
  font-size: 0.6875rem;
  line-height: 1.55;
}

.scenario-criterion-list {
  display: grid;
  gap: 0.5rem;
  margin-top: 0.65rem;
}
.scenario-criterion-list > li {
  border: 1px solid #fed7aa;
  border-radius: 0.7rem;
  background: #fffaf5;
  padding: 0.65rem;
}
.scenario-criterion-list > li.is-complete {
  border-color: #dbeafe;
  background: #f8fbff;
}
.scenario-criterion-list > li.is-answered {
  border-color: #99f6e4;
  background: #f0fdfa;
}

.scenario-criterion-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
}
.scenario-criterion-heading strong {
  color: #1e293b;
  font-size: 0.6875rem;
  font-weight: 850;
}
.scenario-criterion-heading span {
  flex: 0 0 auto;
  color: #9a3412;
  font-size: 0.625rem;
  font-weight: 850;
}

.scenario-criterion-reason {
  margin-top: 0.3rem;
  color: #64748b;
  font-size: 0.625rem;
  line-height: 1.5;
}

.scenario-evidence-list {
  display: grid;
  gap: 0.35rem;
  margin-top: 0.5rem;
}
.scenario-evidence-list li {
  display: grid;
  grid-template-columns: 5.6rem minmax(0, 1fr);
  gap: 0.5rem;
  border-left: 2px solid #bfdbfe;
  padding-left: 0.5rem;
}
.scenario-evidence-list span {
  color: #64748b;
  font-size: 0.5625rem;
  font-weight: 800;
}
.scenario-evidence-list q {
  color: #334155;
  font-size: 0.625rem;
  line-height: 1.5;
}

.scenario-criterion-missing {
  display: flex;
  align-items: flex-start;
  gap: 0.35rem;
  margin-top: 0.45rem;
  color: #c2410c;
  font-size: 0.625rem;
  font-weight: 700;
  line-height: 1.5;
}
.scenario-criterion-missing i {
  margin-top: 0.16rem;
}

.scenario-safety-notice {
  display: flex;
  align-items: flex-start;
  gap: 0.65rem;
  margin-top: 0.75rem;
  border: 1px solid #fecaca;
  border-radius: 0.85rem;
  background: #fff1f2;
  padding: 0.8rem 0.85rem;
  color: #9f1239;
}
.scenario-safety-notice > i {
  margin-top: 0.15rem;
}
.scenario-safety-notice p {
  font-size: 0.6875rem;
  line-height: 1.6;
}
.scenario-safety-notice strong {
  display: block;
  margin-bottom: 0.15rem;
  font-size: 0.75rem;
  font-weight: 900;
}

.scenario-safety-stop {
  display: flex;
  align-items: flex-start;
  gap: 0.65rem;
  margin-top: 0.75rem;
  border: 2px solid #e11d48;
  border-radius: 0.85rem;
  background: #9f1239;
  padding: 0.8rem 0.85rem;
  color: #fff;
}
.scenario-safety-stop > i {
  margin-top: 0.15rem;
}
.scenario-safety-stop strong {
  font-size: 0.75rem;
  font-weight: 900;
}
.scenario-safety-stop p {
  margin-top: 0.15rem;
  font-size: 0.6875rem;
  line-height: 1.55;
}

.scenario-generation-questions {
  margin-top: 1.4rem;
}

.scenario-generation-optional-note {
  margin: 0 0 0.75rem;
  color: #64748b;
  font-size: 0.75rem;
  line-height: 1.6;
}

.scenario-no-content-questions {
  border: 1px solid #99f6e4;
  border-radius: 0.9rem;
  background: #f0fdfa;
  padding: 1rem;
  color: #115e59;
  font-size: 0.75rem;
  line-height: 1.65;
}

.scenario-generation-questions-header {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 0.75rem;
}
.scenario-generation-questions-header h3 {
  color: #0f172a;
  font-size: 1rem;
  font-weight: 900;
  letter-spacing: -0.025em;
}
.scenario-generation-questions-header > span {
  color: #64748b;
  font-size: 0.8125rem;
  font-weight: 750;
}
.scenario-generation-questions-header strong {
  color: #0f766e;
  font-size: 1rem;
  font-weight: 900;
}

.scenario-generation-question-list {
  overflow: hidden;
  margin: 0;
  border: 1px solid #c7d2fe;
  border-radius: 0.95rem;
  background: #fff;
  padding: 0;
  list-style: none;
}

.scenario-generation-question {
  background: #fff;
}
.scenario-generation-question + .scenario-generation-question {
  border-top: 1px solid #e2e8f0;
}
.scenario-generation-question.is-open {
  background: #fbfcff;
}
.scenario-generation-question.is-open .scenario-generation-question-toggle {
  background: #eef2ff;
}
.scenario-generation-question.is-open .scenario-generation-question-toggle > i {
  transform: rotate(180deg);
}
.scenario-generation-question.is-answered:not(.is-open) .scenario-question-number {
  background: #ccfbf1;
  color: #0f766e;
}
.scenario-generation-question.is-skipped:not(.is-open) .scenario-question-number {
  background: #f1f5f9;
  color: #64748b;
}

.scenario-generation-question-toggle {
  display: grid;
  width: 100%;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: center;
  gap: 0.75rem;
  border: 0;
  background: transparent;
  padding: 0.85rem 1rem;
  text-align: left;
  transition: background 150ms ease;
}
.scenario-generation-question-toggle:hover {
  background: #f8fafc;
}
.scenario-generation-question-toggle:focus-visible {
  position: relative;
  z-index: 1;
  outline: 3px solid rgba(79, 70, 229, 0.2);
  outline-offset: -3px;
}
.scenario-generation-question-toggle > i {
  color: #475569;
  font-size: 0.6875rem;
  transition: transform 160ms ease;
}

.scenario-generation-question-heading {
  display: grid;
  min-width: 0;
  gap: 0.2rem;
}
.scenario-generation-question-heading strong {
  color: #1e293b;
  font-size: 0.75rem;
  font-weight: 900;
}
.scenario-generation-question-heading small {
  overflow: hidden;
  color: #475569;
  font-size: 0.75rem;
  line-height: 1.55;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.scenario-generation-question-heading .scenario-generation-example-preview {
  color: #0f766e;
}

.scenario-generation-question-part {
  width: fit-content;
  border-radius: 9999px;
  background: #e0e7ff;
  padding: 0.12rem 0.42rem;
  color: #4338ca;
  font-size: 0.5625rem;
  font-weight: 900;
}

.scenario-generation-question-body {
  border-top: 1px solid #e0e7ff;
  padding: 1rem;
}

.scenario-generation-question-text {
  max-width: 42rem;
  color: #0f172a;
  font-size: 0.9375rem;
  font-weight: 800;
  line-height: 1.65;
  word-break: keep-all;
}

.scenario-generation-example-answer {
  display: grid;
  gap: 0.3rem;
  margin-top: 0.85rem;
  border: 1px solid #99f6e4;
  border-radius: 0.75rem;
  background: #f0fdfa;
  padding: 0.8rem 0.9rem;
}
.scenario-generation-example-answer strong {
  color: #115e59;
  font-size: 0.75rem;
  font-weight: 900;
}
.scenario-generation-example-answer p {
  margin: 0;
  color: #134e4a;
  font-size: 0.8125rem;
  line-height: 1.7;
  word-break: keep-all;
}
.scenario-generation-example-answer small {
  color: #64748b;
  font-size: 0.6875rem;
  line-height: 1.5;
}

.scenario-generation-answer {
  display: grid;
  gap: 0.4rem;
  margin-top: 0.9rem;
}
.scenario-generation-answer > span {
  color: #475569;
  font-size: 0.6875rem;
  font-weight: 850;
}
.scenario-generation-answer textarea {
  width: 100%;
  min-height: 7rem;
  resize: vertical;
  border: 1px solid #cbd5e1;
  border-radius: 0.75rem;
  background: #fff;
  padding: 0.75rem 0.8rem;
  color: #1e293b;
  font-size: 0.8125rem;
  line-height: 1.6;
}
.scenario-generation-answer textarea::placeholder {
  color: #94a3b8;
}
.scenario-generation-answer textarea:focus {
  border-color: #14b8a6;
  outline: 3px solid rgba(20, 184, 166, 0.14);
}

.scenario-generation-consent-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-top: 0.9rem;
}
.scenario-generation-consent-actions button {
  display: inline-flex;
  min-height: 2.5rem;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
  border: 1px solid #cbd5e1;
  border-radius: 0.7rem;
  background: #fff;
  padding: 0.5rem 0.8rem;
  color: #475569;
  font-size: 0.75rem;
  font-weight: 850;
}
.scenario-generation-consent-actions button:focus-visible {
  outline: 3px solid rgba(20, 184, 166, 0.2);
  outline-offset: 2px;
}
.scenario-generation-consent-actions .is-yes.is-active {
  border-color: #0f766e;
  background: #ccfbf1;
  color: #115e59;
}
.scenario-generation-consent-actions .is-no.is-active,
.scenario-generation-consent-actions .is-later.is-active {
  border-color: #94a3b8;
  background: #f1f5f9;
  color: #334155;
}

.scenario-generation-question-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.55rem;
  margin-top: 0.75rem;
}
.scenario-generation-question-actions button {
  display: inline-flex;
  min-height: 2.5rem;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
  border-radius: 0.7rem;
  padding: 0.5rem 0.85rem;
  font-size: 0.75rem;
  font-weight: 850;
}

.scenario-generation-skip {
  border: 1px solid #cbd5e1;
  background: #fff;
  color: #475569;
}
.scenario-generation-skip:hover {
  border-color: #94a3b8;
  color: #1e293b;
}

.scenario-generation-save {
  border: 1px solid #0f766e;
  background: #0f766e;
  color: #fff;
}
.scenario-generation-save:hover {
  background: #115e59;
}

.scenario-generation-skip:focus-visible,
.scenario-generation-save:focus-visible {
  outline: 3px solid rgba(20, 184, 166, 0.22);
  outline-offset: 2px;
}

.scenario-question-progress {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin: 1rem 0 0.65rem;
  color: #64748b;
  font-size: 0.6875rem;
  font-weight: 750;
}
.scenario-question-progress strong {
  color: #0f766e;
  font-size: 0.875rem;
  font-weight: 900;
}

.scenario-question-group {
  overflow: hidden;
  border: 1px solid #cbd5e1;
  border-radius: 0.95rem;
  background: #fff;
}
.scenario-question-group + .scenario-question-group {
  margin-top: 0.8rem;
}
.scenario-question-group.is-consent {
  border-color: #99f6e4;
}
.scenario-question-group.is-consent .scenario-question-group-header {
  background: #f0fdfa;
}
.scenario-question-group.is-consent .scenario-question-group-icon {
  background: #ccfbf1;
  color: #0f766e;
}
.scenario-question-group.is-safety {
  border-color: #fecaca;
}
.scenario-question-group.is-safety .scenario-question-group-header {
  background: #fff1f2;
}
.scenario-question-group.is-safety .scenario-question-group-icon {
  background: #ffe4e6;
  color: #be123c;
}
.scenario-question-group.is-required {
  border-color: #c7d2fe;
}
.scenario-question-group.is-required .scenario-question-group-header {
  background: #eef2ff;
}
.scenario-question-group.is-required .scenario-question-group-icon {
  background: #e0e7ff;
  color: #4338ca;
}
.scenario-question-group.is-supplemental {
  border-color: #fde68a;
}
.scenario-question-group.is-supplemental .scenario-question-group-header {
  background: #fffbeb;
}
.scenario-question-group.is-supplemental .scenario-question-group-icon {
  background: #fef3c7;
  color: #b45309;
}

.scenario-question-group-header {
  display: flex;
  align-items: flex-start;
  gap: 0.7rem;
  border-bottom: 1px solid rgba(203, 213, 225, 0.65);
  padding: 0.8rem 0.9rem;
}
.scenario-question-group-header h3 {
  color: #0f172a;
  font-size: 0.8125rem;
  font-weight: 900;
}
.scenario-question-group-header div > div > span {
  border-radius: 9999px;
  background: rgba(255, 255, 255, 0.8);
  padding: 0.2rem 0.45rem;
  color: #64748b;
  font-size: 0.625rem;
  font-weight: 800;
}
.scenario-question-group-header p {
  margin-top: 0.25rem;
  color: #64748b;
  font-size: 0.6875rem;
  line-height: 1.5;
}

.scenario-question-group-icon {
  display: inline-flex;
  width: 2rem;
  height: 2rem;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border-radius: 0.65rem;
  background: #e2e8f0;
  color: #475569;
  font-size: 0.75rem;
}

.scenario-question-list {
  display: grid;
}

.scenario-question-item {
  padding: 0.9rem;
}
.scenario-question-item + .scenario-question-item {
  border-top: 1px solid #e2e8f0;
}
.scenario-question-item.is-present {
  background: #f8fffd;
}
.scenario-question-item.is-absent {
  background: #f8fafc;
}
.scenario-question-item.is-deferred {
  background: #fffbeb;
}

.scenario-question-meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.45rem;
}
.scenario-question-meta > strong {
  color: #334155;
  font-size: 0.6875rem;
  font-weight: 850;
}

.scenario-question-number {
  display: inline-flex;
  width: 1.65rem;
  height: 1.65rem;
  align-items: center;
  justify-content: center;
  border-radius: 0.55rem;
  background: #eef2ff;
  color: #4338ca;
  font-size: 0.625rem;
  font-weight: 900;
}

.scenario-question-gain {
  margin-left: auto;
  border-radius: 9999px;
  background: #f1f5f9;
  padding: 0.2rem 0.45rem;
  color: #64748b;
  font-size: 0.5625rem;
  font-weight: 750;
}

.scenario-question-text {
  margin-top: 0.65rem;
  color: #1e293b;
  font-size: 0.8125rem;
  font-weight: 650;
  line-height: 1.72;
  word-break: keep-all;
  overflow-wrap: anywhere;
}

.scenario-linked-criteria {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
  margin-top: 0.6rem;
}
.scenario-linked-criteria > span:not(.scenario-linked-label) {
  border-radius: 9999px;
  background: #eef2ff;
  padding: 0.22rem 0.45rem;
  color: #4338ca;
  font-size: 0.5625rem;
  font-weight: 750;
}

.scenario-linked-label {
  align-self: center;
  color: #64748b;
  font-size: 0.5625rem;
  font-weight: 850;
}

.scenario-question-rationale {
  margin-top: 0.65rem;
}
.scenario-question-rationale summary {
  width: fit-content;
  cursor: pointer;
  color: #64748b;
  font-size: 0.6875rem;
  font-weight: 750;
}
.scenario-question-rationale dl {
  display: grid;
  gap: 0.45rem;
  margin-top: 0.55rem;
  border-radius: 0.7rem;
  background: #f8fafc;
  padding: 0.7rem;
}
.scenario-question-rationale dl > div {
  display: grid;
  grid-template-columns: 4.2rem minmax(0, 1fr);
  gap: 0.55rem;
}
.scenario-question-rationale dt {
  color: #475569;
  font-size: 0.625rem;
  font-weight: 850;
}
.scenario-question-rationale dd {
  color: #64748b;
  font-size: 0.6875rem;
  line-height: 1.55;
}

.scenario-question-response {
  display: grid;
  gap: 0.65rem;
  margin-top: 0.8rem;
}

.scenario-status-options {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
}
.scenario-status-options button {
  display: inline-flex;
  min-height: 2.25rem;
  align-items: center;
  gap: 0.35rem;
  border: 1px solid #cbd5e1;
  border-radius: 0.65rem;
  background: #fff;
  padding: 0.45rem 0.65rem;
  color: #64748b;
  font-size: 0.6875rem;
  font-weight: 800;
}
.scenario-status-options button:hover {
  border-color: #94a3b8;
  color: #334155;
}
.scenario-status-options button:focus-visible {
  outline: 3px solid rgba(20, 184, 166, 0.2);
  outline-offset: 1px;
}
.scenario-status-options button.is-active {
  border-color: #0f766e;
  background: #ccfbf1;
  color: #0f766e;
}

.scenario-question-response label {
  display: grid;
  gap: 0.35rem;
}
.scenario-question-response label > span {
  color: #475569;
  font-size: 0.6875rem;
  font-weight: 800;
}
.scenario-question-response label small {
  margin-left: 0.35rem;
  color: #94a3b8;
  font-size: 0.5625rem;
  font-weight: 700;
}
.scenario-question-response label textarea {
  width: 100%;
  resize: vertical;
  border: 1px solid #cbd5e1;
  border-radius: 0.7rem;
  background: #fff;
  padding: 0.65rem 0.7rem;
  color: #1e293b;
  font-size: 0.75rem;
  line-height: 1.55;
}
.scenario-question-response label textarea::placeholder {
  color: #94a3b8;
}
.scenario-question-response label textarea:focus {
  border-color: #14b8a6;
  outline: 3px solid rgba(20, 184, 166, 0.14);
}

.scenario-answer-required {
  border-radius: 0.55rem;
  background: #fff7ed;
  padding: 0.45rem 0.55rem;
  color: #c2410c;
  font-size: 0.625rem;
  font-weight: 750;
}

.scenario-drawer-footer {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 0.75rem 1rem;
  border-top: 1px solid #cbd5e1;
  background: #fff;
  padding: 0.85rem 1.1rem;
  box-shadow: 0 -8px 24px rgba(15, 23, 42, 0.06);
}
.scenario-drawer-footer > div {
  display: flex;
  align-items: baseline;
  gap: 0.2rem;
  color: #64748b;
  font-size: 0.6875rem;
  font-weight: 700;
}
.scenario-drawer-footer > div strong {
  color: #0f766e;
  font-size: 1rem;
  font-weight: 900;
}

.scenario-generation-footer > div {
  gap: 0.25rem;
}
.scenario-generation-footer .scenario-reevaluate-button {
  min-width: 8.5rem;
}

.scenario-reevaluate-button {
  display: inline-flex;
  min-height: 2.65rem;
  align-items: center;
  justify-content: center;
  gap: 0.45rem;
  border: 1px solid #0f766e;
  border-radius: 0.75rem;
  background: #0f766e;
  padding: 0.55rem 0.85rem;
  color: #fff;
  font-size: 0.75rem;
  font-weight: 850;
  box-shadow: 0 4px 12px rgba(15, 118, 110, 0.18);
}
.scenario-reevaluate-button:hover {
  background: #115e59;
}
.scenario-reevaluate-button:focus-visible {
  outline: 3px solid rgba(20, 184, 166, 0.25);
  outline-offset: 2px;
}

.scenario-reevaluation-message {
  grid-column: 1/-1;
  border-radius: 0.65rem;
  background: #fff7ed;
  padding: 0.55rem 0.65rem;
  color: #9a3412;
  font-size: 0.6875rem;
  font-weight: 700;
  line-height: 1.5;
}
.scenario-reevaluation-message.is-ready {
  background: #ecfdf5;
  color: #166534;
}
.scenario-reevaluation-message.is-stopped {
  background: #fff1f2;
  color: #9f1239;
}

@keyframes scenario-backdrop-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes scenario-drawer-in {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
}
@container page-scenario-sets (min-width: 1024px) {
  .scenario-workspace {
    grid-template-columns: minmax(18rem, 22rem) minmax(0, 1fr);
  }
  .scenario-list-panel {
    position: sticky;
    top: 1rem;
  }
}
@container page-scenario-sets (min-width: 1440px) {
  .scenario-content-grid,
  .scenario-extraction-grid,
  .raw-design-note-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@container page-scenario-sets (max-width: 639px) {
  .scenario-filter-panel,
  .scenario-transcript {
    padding: 0.75rem;
  }
  .scenario-phase-summary {
    min-width: 0;
    width: 100%;
  }
  .scenario-detail-actions {
    width: 100%;
  }
  .scenario-raw-actions {
    width: 100%;
  }
  .scenario-question-drawer {
    width: 100%;
    border-left: 0;
  }
  .scenario-drawer-header,
  .scenario-drawer-scroll,
  .scenario-drawer-footer {
    padding-right: 0.85rem;
    padding-left: 0.85rem;
  }
  .scenario-drawer-footer {
    grid-template-columns: minmax(0, 1fr);
  }
  .scenario-reevaluate-button {
    width: 100%;
  }
  .scenario-question-drawer.is-media-generation .scenario-drawer-scroll {
    padding-right: 0.85rem;
    padding-left: 0.85rem;
  }
  .scenario-generation-summary-body dl {
    grid-template-columns: minmax(0, 1fr);
  }
  .scenario-generation-question-toggle {
    padding: 0.75rem;
  }
  .scenario-generation-question-heading small {
    display: -webkit-box;
    overflow: hidden;
    white-space: normal;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
  .scenario-generation-question-body {
    padding: 0.85rem 0.75rem;
  }
  .scenario-generation-question-actions {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .scenario-bubble {
    max-width: 94%;
  }
  .scenario-dialogue-list {
    padding-inline: 0.75rem;
  }
  .scenario-content-studio {
    margin: 0.75rem;
  }
  .raw-design-notes {
    margin: 0.75rem;
  }
  .scenario-content-header,
  .scenario-extraction-header {
    flex-direction: column;
  }
  .scenario-extraction-method {
    align-self: flex-start;
  }
  .scenario-extraction {
    margin: 0.75rem;
  }
  .scenario-basis-groups {
    grid-template-columns: minmax(0, 1fr);
  }
  .scenario-basis-group.is-dialogue {
    grid-column: auto;
  }
  .scenario-basis-heading {
    flex-direction: column;
  }
  .scenario-basis-count {
    align-self: flex-start;
  }
  .scenario-basis-group dl > div {
    grid-template-columns: minmax(0, 1fr);
    gap: 0.2rem;
  }
  .scenario-extraction-item {
    grid-template-columns: 1.75rem minmax(0, 1fr);
    gap: 0.55rem;
    padding: 0.65rem;
  }
  .scenario-extraction-index {
    width: 1.75rem;
    height: 1.75rem;
  }
  .scenario-extraction-meta {
    align-items: flex-start;
    flex-direction: column;
  }
}
@media (prefers-reduced-motion: reduce) {
  .scenario-drawer-backdrop,
  .scenario-question-drawer {
    animation: none;
  }
  .scenario-followup-trigger,
  .scenario-score-track span {
    transition: none;
  }
}
/* Scenario library: compact navigator and focused detail view. */
.scenario-library-main {
  width: 100%;
  max-width: 100rem;
  margin: 0 auto;
  padding: 1.25rem clamp(1rem, 2vw, 2rem) 2rem;
}

.scenario-load-error,
.scenario-loading {
  border: 1px solid #dbe6f5;
  border-radius: 0.75rem;
  background: #fff;
  padding: 1.25rem;
}

.scenario-load-error {
  display: flex;
  justify-content: space-between;
  color: #b91c1c;
}

.scenario-load-error button {
  color: #1d4ed8;
  font-weight: 700;
}

.scenario-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  min-height: 18rem;
  color: #64748b;
}

.scenario-library .scenario-workspace {
  display: grid;
  grid-template-columns: minmax(19rem, 23.25rem) minmax(0, 1fr);
  gap: 0.75rem;
  align-items: stretch;
  margin-top: 0;
}

.scenario-library .scenario-list-panel,
.scenario-library .scenario-detail-panel {
  min-width: 0;
  border-color: #dce7f5;
  border-radius: 0.75rem;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.025);
}

.scenario-library .scenario-list-panel {
  position: static;
  display: flex;
  flex-direction: column;
  min-height: min(48rem, 100vh - 8rem);
}

.scenario-library .scenario-list-header {
  border: 0;
  padding: 1rem 1rem 0.75rem;
}

.scenario-list-heading {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 0.5rem;
}

.scenario-list-heading h2 {
  color: #0f172a;
  font-size: 1.1rem;
  font-weight: 800;
  white-space: nowrap;
}

.scenario-library .scenario-result-count {
  min-width: 0;
  background: #eff6ff;
  color: #1d4ed8;
  padding: 0.25rem 0.45rem;
}

.scenario-list-filters {
  display: grid;
  gap: 0.5rem;
  padding: 0 0.9rem 0.65rem;
}

.scenario-search-wrap,
.scenario-category-wrap {
  position: relative;
  display: flex;
  align-items: center;
  min-width: 0;
}

.scenario-search-wrap > i,
.scenario-category-wrap > i:first-child {
  position: absolute;
  left: 0.85rem;
  z-index: 1;
  color: #8496b1;
  font-size: 0.85rem;
  pointer-events: none;
}

.scenario-category-wrap > i:last-child {
  position: absolute;
  right: 0.85rem;
  color: #62748e;
  font-size: 0.65rem;
  pointer-events: none;
}

.scenario-list-filters .scenario-search-input,
.scenario-category-wrap select {
  width: 100%;
  min-height: 2.5rem;
  border: 1px solid #d4e0f0;
  border-radius: 0.5rem;
  background: #fff;
  padding: 0.55rem 2.25rem;
  color: #1f3352;
  font-size: 0.78rem;
  font-weight: 600;
  outline: none;
}

.scenario-category-wrap select {
  appearance: none;
  cursor: pointer;
}

.scenario-list-filters .scenario-search-input:focus,
.scenario-category-wrap select:focus-visible {
  border-color: #4088fb;
  box-shadow: 0 0 0 3px rgba(64, 136, 251, 0.14);
}

.scenario-library .scenario-list.is-raw.is-only-list {
  display: block;
  flex: 1 1 auto;
  max-height: none;
  overflow-y: auto;
  padding: 0 0.8rem;
}

.scenario-library .scenario-list-item.is-raw {
  align-items: center;
  min-height: 5.5rem;
  gap: 0.5rem;
  border: 1px solid transparent;
  border-bottom-color: #e9eff7;
  border-radius: 0;
  padding: 0.7rem 0.65rem;
  color: #1d3559;
  box-shadow: none;
}

.scenario-library .scenario-list-item.is-raw:hover {
  background: #f6f9ff;
}

.scenario-library .scenario-list-item.is-raw.is-selected {
  border-color: #4387fb;
  border-radius: 0.5rem;
  background: #edf4ff;
  box-shadow: none;
}

.scenario-list-item-content {
  display: grid;
  min-width: 0;
  flex: 1 1 auto;
  gap: 0.2rem;
  text-align: left;
}

.scenario-list-id-row {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
}

.scenario-uploaded-badge {
  border-radius: 9999px;
  background: #e8f4ff;
  padding: 0.1rem 0.35rem;
  color: #1762d4;
  font-size: 0.6rem;
  font-weight: 800;
}

.scenario-library .scenario-list-item .scenario-id {
  color: #466587;
  font-size: 0.68rem;
  font-weight: 800;
}

.scenario-library .scenario-list-item strong {
  overflow: hidden;
  color: #142644;
  font-size: 0.86rem;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.scenario-library .scenario-list-item small {
  overflow: hidden;
  color: #6b83a2;
  font-size: 0.68rem;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.scenario-library .scenario-list-item > i {
  flex: 0 0 auto;
  color: #8aa6cb;
  font-size: 0.7rem;
}

.scenario-library .scenario-list-item.is-selected > i,
.scenario-library .scenario-list-item.is-selected .scenario-id {
  color: #1262e6;
}

.scenario-list-empty {
  display: grid;
  justify-items: center;
  gap: 0.55rem;
  padding: 3rem 1rem;
  color: #6b83a2;
  font-size: 0.85rem;
}

.scenario-list-empty button {
  color: #1262e6;
  font-weight: 800;
}

.scenario-list-pagination {
  display: flex;
  justify-content: center;
  gap: 0.35rem;
  border-top: 1px solid #edf2f9;
  padding: 0.8rem;
}

.scenario-list-pagination button {
  display: inline-flex;
  width: 2rem;
  height: 2rem;
  align-items: center;
  justify-content: center;
  border: 1px solid #dbe6f6;
  border-radius: 0.45rem;
  color: #34517a;
  font-size: 0.75rem;
  font-weight: 800;
}

.scenario-list-pagination button:hover:not(:disabled) {
  border-color: #4387fb;
  background: #eff6ff;
}

.scenario-list-pagination button.is-active {
  border-color: #1367ed;
  background: #1367ed;
  color: #fff;
}

.scenario-list-pagination button:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}

.scenario-list-pagination button:focus-visible {
  outline: 3px solid #93c5fd;
  outline-offset: 2px;
}

.scenario-library .scenario-detail-panel {
  min-height: min(48rem, 100vh - 8rem);
}

.scenario-library .scenario-detail-header {
  border: 0;
  padding: 1.5rem 1.75rem 1.35rem;
}

.scenario-detail-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
}

.scenario-detail-identity {
  min-width: 0;
}

.scenario-library .scenario-detail-id {
  display: inline;
  border: 0;
  border-radius: 0;
  background: none;
  padding: 0;
  color: #456389;
  font-size: 0.78rem;
}

.scenario-detail-identity h2 {
  margin-top: 0.45rem;
  color: #0d1c38;
  font-size: clamp(1.35rem, 2vw, 1.8rem);
  font-weight: 800;
  letter-spacing: -0.025em;
  line-height: 1.25;
}

.scenario-detail-meta {
  margin-top: 0.45rem;
  color: #5d78a0;
  font-size: 0.82rem;
  font-weight: 600;
  line-height: 1.55;
}

.scenario-library .scenario-detail-actions {
  display: flex;
  width: auto;
  gap: 0.5rem;
}

.scenario-analysis-button,
.scenario-export-toggle {
  display: inline-flex;
  min-height: 2.5rem;
  align-items: center;
  justify-content: center;
  gap: 0.55rem;
  border-radius: 0.5rem;
  padding: 0.55rem 0.9rem;
  font-size: 0.78rem;
  font-weight: 800;
  white-space: nowrap;
  cursor: pointer;
}

.scenario-analysis-button {
  background: #1367ed;
  color: #fff;
}

.scenario-analysis-button:hover {
  background: #0954d3;
}

.scenario-export-menu {
  position: relative;
}

.scenario-export-toggle {
  border: 1px solid #d5e1f0;
  background: #fff;
  color: #243d62;
  list-style: none;
}

.scenario-export-toggle::-webkit-details-marker {
  display: none;
}

.scenario-export-toggle:hover {
  border-color: #4088fb;
  background: #f6f9ff;
}

.scenario-library .scenario-export-actions {
  position: absolute;
  z-index: 5;
  top: calc(100% + 0.35rem);
  right: 0;
  display: grid;
  min-width: 11rem;
  gap: 0.2rem;
  border: 1px solid #dbe6f5;
  border-radius: 0.55rem;
  background: #fff;
  padding: 0.3rem;
  box-shadow: 0 8px 24px rgba(22, 45, 80, 0.12);
}

.scenario-library .scenario-export-button {
  justify-content: flex-start;
  border: 0;
  padding: 0.55rem 0.65rem;
  color: #243d62;
  font-size: 0.73rem;
}

.scenario-library .scenario-export-button:hover {
  background: #eff6ff;
  color: #125dd6;
}

.scenario-analysis-button:focus-visible,
.scenario-export-toggle:focus-visible {
  outline: 3px solid #93c5fd;
  outline-offset: 2px;
}

.scenario-detail-tabs {
  display: flex;
  gap: 0.4rem;
  margin: 0 1.45rem;
  border-bottom: 1px solid #dbe6f3;
  overflow-x: auto;
}

.scenario-detail-tabs button {
  min-width: 5.5rem;
  border-bottom: 3px solid transparent;
  padding: 0.8rem 0.85rem;
  color: #56739a;
  font-size: 0.82rem;
  font-weight: 800;
  white-space: nowrap;
}

.scenario-detail-tabs button:hover {
  color: #125dd6;
}

.scenario-detail-tabs button.is-active {
  border-bottom-color: #1367ed;
  color: #1262e6;
}

.scenario-detail-tabs button:focus-visible {
  outline: 3px solid #93c5fd;
  outline-offset: -3px;
}

.scenario-overview {
  padding: 1.5rem 1.75rem 2rem;
}

.scenario-overview-intro {
  border-bottom: 1px solid #dce6f3;
  padding-bottom: 1.15rem;
  color: #4f6d95;
  font-size: 0.86rem;
  line-height: 1.7;
}

.scenario-overview-intro p + p {
  margin-top: 0.2rem;
}

.scenario-overview .scenario-basis {
  margin-top: 1.25rem;
  border: 0;
  padding: 0;
}

.scenario-overview .scenario-basis-groups {
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1.5rem;
  margin: 0;
}

.scenario-overview .scenario-basis-group {
  border: 0;
  border-radius: 0;
  background: transparent;
}

.scenario-overview .scenario-basis-group + .scenario-basis-group {
  border-left: 1px solid #dce6f3;
  padding-left: 1.5rem;
}

.scenario-overview .scenario-basis-group h4,
.scenario-overview-dialogue h3 {
  margin-bottom: 0.75rem;
  color: #101e3b;
  font-size: 1rem;
  font-weight: 800;
}

.scenario-overview .scenario-basis-group dl {
  padding: 0;
}

.scenario-overview .scenario-basis-group dl > div {
  grid-template-columns: 6.3rem minmax(0, 1fr);
  gap: 0.7rem;
  border-top: 1px solid #e7edf6;
  padding: 0.65rem 0;
}

.scenario-overview .scenario-basis-group dt {
  color: #657fa4;
  font-size: 0.77rem;
}

.scenario-overview .scenario-basis-group dd {
  color: #172b4c;
  font-size: 0.82rem;
  font-weight: 700;
}

.scenario-overview-dialogue {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 1rem;
  margin-top: 1.2rem;
  border-top: 1px solid #dce6f3;
  padding-top: 1.2rem;
}

.scenario-overview-dialogue p {
  color: #5b779e;
  font-size: 0.82rem;
  line-height: 1.5;
}

.scenario-overview-dialogue button {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  color: #1262e6;
  font-size: 0.82rem;
  font-weight: 800;
  white-space: nowrap;
}

.scenario-overview-dialogue button:hover {
  text-decoration: underline;
}

.scenario-elements-panel,
.scenario-dialogue-panel {
  min-height: 21rem;
  padding: 0.75rem;
}

.scenario-elements-intro {
  margin: 0.5rem 0.75rem 0;
  color: #637d9f;
  font-size: 0.8rem;
}

.scenario-library .scenario-detail-footer {
  margin-top: 1.5rem;
  background: transparent;
}

.scenario-import-backdrop {
  position: fixed;
  z-index: 80;
  inset: 0;
  display: grid;
  grid-template-rows: minmax(0, 1fr);
  place-items: center;
  overflow-y: auto;
  background: rgba(15, 30, 56, 0.55);
  padding: 1rem;
}

.scenario-import-dialog {
  width: min(100%, 46rem);
  max-height: min(100%, 56rem);
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  border-radius: 0.85rem;
  background: #fff;
  box-shadow: 0 24px 56px rgba(10, 30, 60, 0.23);
}

.scenario-import-dialog header,
.scenario-import-dialog footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 1rem 1.2rem;
}

.scenario-import-dialog header {
  border-bottom: 1px solid #e4ebf5;
}

.scenario-import-dialog header h2 {
  color: #102441;
  font-size: 1.1rem;
  font-weight: 800;
}

.scenario-import-dialog header p {
  margin-top: 0.25rem;
  color: #6b83a2;
  font-size: 0.75rem;
}

.scenario-import-dialog header button {
  color: #536b89;
}

.scenario-import-content {
  display: grid;
  gap: 0.7rem;
  padding: 1.2rem;
  overflow: auto;
  min-height: 0;
}

@container page-scenario-sets (max-width: 640px) {
  .scenario-import-content {
    flex: 0 0 auto;
    overflow: visible;
  }
}
.scenario-import-content label {
  color: #1d3559;
  font-size: 0.82rem;
  font-weight: 800;
}

.scenario-import-content input {
  width: 100%;
  border: 1px solid #cfddef;
  border-radius: 0.5rem;
  padding: 0.6rem;
  font-size: 0.78rem;
}

.scenario-import-error {
  color: #b91c1c;
  font-size: 0.75rem;
}

.scenario-import-notice {
  border: 1px solid #bdd9f6;
  border-radius: 0.5rem;
  background: #eff7ff;
  padding: 0.7rem 0.8rem;
  color: #174a7c;
  font-size: 0.78rem;
  line-height: 1.5;
}

.scenario-import-preview {
  display: grid;
  gap: 0.2rem;
  border: 1px solid #d9e8ff;
  border-radius: 0.5rem;
  background: #f4f8ff;
  padding: 0.8rem;
  color: #1e3a5f;
  font-size: 0.75rem;
}

.scenario-import-preview strong {
  font-size: 0.85rem;
}

.scenario-import-dialog footer {
  justify-content: flex-end;
  border-top: 1px solid #e4ebf5;
}

.scenario-import-dialog footer button {
  border: 1px solid #d3e0ee;
  border-radius: 0.5rem;
  padding: 0.55rem 0.9rem;
  color: #2f4b6d;
  font-size: 0.8rem;
  font-weight: 800;
}

.scenario-import-dialog footer .scenario-import-save {
  border-color: #1367ed;
  background: #1367ed;
  color: #fff;
}

.scenario-import-dialog footer button:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.scenario-import-status {
  color: #1557a8;
  font-size: 0.82rem;
  font-weight: 700;
}

.scenario-import-progress {
  height: 0.4rem;
  overflow: hidden;
  border-radius: 1rem;
  background: #e5edf8;
}

.scenario-import-progress span {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: #1267dd;
  transition: width 250ms ease;
}

.scenario-import-tabs {
  display: flex;
  gap: 0.4rem;
  overflow: auto;
  padding-bottom: 0.25rem;
}

.scenario-import-tabs button {
  flex: 0 0 auto;
  max-width: 15rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border: 1px solid #d7e3f3;
  border-radius: 0.45rem;
  padding: 0.45rem 0.65rem;
  color: #45617f;
  font-size: 0.76rem;
}

.scenario-import-tabs button.active {
  color: #075bc5;
  border-color: #81b1fa;
  background: #edf5ff;
}

.scenario-import-review {
  display: grid;
  gap: 0.65rem;
  border: 1px solid #dce7f4;
  border-radius: 0.6rem;
  padding: 0.9rem;
  color: #55718d;
  font-size: 0.76rem;
}

.scenario-import-review h3 {
  color: #183556;
  font-size: 0.88rem;
  font-weight: 800;
  margin-top: 0.35rem;
}

.scenario-import-review label {
  display: grid;
  gap: 0.25rem;
}

.scenario-import-review input, .scenario-import-review textarea {
  width: 100%;
  border: 1px solid #cad9ea;
  border-radius: 0.4rem;
  padding: 0.5rem;
  color: #193553;
  font: inherit;
  resize: vertical;
}

.scenario-import-review input:focus, .scenario-import-review textarea:focus {
  outline: 2px solid #83b8ff;
  outline-offset: 1px;
}

.scenario-import-fields {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.55rem;
}

.scenario-import-summary {
  border-radius: 0.45rem;
  background: #f2f7fd;
  padding: 0.65rem;
  color: #25496d;
  line-height: 1.5;
}

.scenario-import-review details {
  border-top: 1px solid #e2eaf4;
  padding-top: 0.5rem;
}

.scenario-import-review details p {
  padding: 0.25rem 0;
}

.scenario-import-missing {
  color: #9b6120;
}

@container page-scenario-sets (max-width: 36rem) {
  .scenario-import-fields {
    grid-template-columns: 1fr;
  }
}
@container page-scenario-sets (max-width: 1279px) {
  .scenario-library .scenario-workspace {
    grid-template-columns: minmax(0, 1fr);
  }
  .scenario-library .scenario-list-panel {
    min-height: 0;
  }
  .scenario-library .scenario-list.is-raw.is-only-list {
    max-height: none;
    overflow-y: visible;
  }
  .scenario-library .scenario-detail-panel {
    min-height: 0;
  }
}
@container page-scenario-sets (max-width: 639px) {
  .scenario-library-main {
    padding: 0.75rem;
  }
  .scenario-list-heading h2 {
    font-size: 0.95rem;
  }
  .scenario-detail-top {
    flex-direction: column;
  }
  .scenario-library .scenario-detail-actions {
    width: 100%;
  }
  .scenario-library .scenario-detail-header {
    padding: 1rem;
  }
  .scenario-detail-tabs {
    margin: 0 0.75rem;
  }
  .scenario-detail-tabs button {
    min-width: auto;
    padding-inline: 0.65rem;
    font-size: 0.75rem;
  }
  .scenario-overview {
    padding: 1rem;
  }
  .scenario-overview .scenario-basis-groups {
    grid-template-columns: minmax(0, 1fr);
    gap: 1rem;
  }
  .scenario-overview .scenario-basis-group + .scenario-basis-group {
    border-left: 0;
    border-top: 1px solid #dce6f3;
    padding: 1rem 0 0;
  }
  .scenario-overview-dialogue {
    align-items: flex-start;
    flex-direction: column;
  }
}
.scenario-detail-top {
  flex-wrap: wrap;
}

.scenario-detail-identity {
  flex: 1 1 20rem;
}

.scenario-detail-identity h2 {
  word-break: keep-all;
  overflow-wrap: anywhere;
}

.scenario-detail-meta {
  word-break: keep-all;
  overflow-wrap: anywhere;
}

.scenario-library .scenario-detail-actions {
  flex: 0 1 auto;
  flex-wrap: wrap;
}

.scenario-library .scenario-list-item strong,
.scenario-library .scenario-list-item small {
  white-space: normal;
  overflow: visible;
  overflow-wrap: anywhere;
  word-break: keep-all;
}

@container page-scenario-sets (max-width: 1279px) {
  .scenario-library .scenario-list.is-raw.is-only-list {
    max-height: min(18rem, 32dvh);
    overflow-y: auto;
  }
}`],
})
export class PageScenarioSetsComponent implements OnInit, OnDestroy {
    public readonly showGeneratedSets: boolean = false;
    public loading: boolean = true;
    public errorMessage: string = '';
    public searchText: string = '';
    public selectedCategory: string = 'all';
    public selectedScenario: any = null;
    public activeDetailTab: 'overview' | 'dialogue' | 'elements' = 'overview';
    public scenarioPage: number = 1;
    public readonly scenarioPageSize: number = 5;
    public scenarioExporting: '' | 'json' | 'csv' = '';
    public scenarioUploadOpen: boolean = false;
    public scenarioImportPreview: any = null;
    public scenarioImportError: string = '';
    public scenarioImportNotice: string = '';
    public scenarioImportSaving: boolean = false;
    public scenarioImportJob: any = null;
    public scenarioImportSelected: number = 0;
    public scenarioImportStatus: string = '';
    private scenarioImportFile: File | null = null;
    public scenarioImportExistingUploadId: string = '';
    private scenarioUploadReturnFocus: HTMLElement | null = null;
    private readonly onAgentScenarioImported = (event: Event) => {
        const items = (event as CustomEvent)?.detail?.items;
        const uploadId = Array.isArray(items) ? items[0]?.uploaded_id : '';
        if (uploadId) {
            const url = new URL(location.href);
            url.searchParams.set('upload', String(uploadId));
            history.replaceState({}, '', `${url.pathname}${url.search}`);
        }
        void this.load();
    };
    private readonly onAgentScenarioImportReady = (event: Event) => {
        const detail = (event as CustomEvent)?.detail;
        if (detail?.job?.job_id && Array.isArray(detail.job.scenarios)) {
            void this.showImportReview(detail.job);
        } else if (typeof detail?.jobId === 'string') {
            void this.openImportJob(detail.jobId);
        }
    };
    private readonly onAgentPageContext = (event: Event) => {
        const respond = (event as CustomEvent).detail?.respond;
        if (typeof respond === 'function' && this.selectedScenario) {
            respond({ scenario_id: String(this.selectedScenario.id || ''),
                uploaded_id: String(this.selectedScenario.uploaded_id || '') });
        }
    };
    public selectedPromptMedia: any = { trauma: 'image', positive: 'image' };
    public copiedPromptKey: string = '';
    public data: any = {
        summary: {
            category_count: 0,
            scenario_count: 0,
            turn_count: 0,
            turns_per_scenario: 0,
            trauma_assessment_turns: 0,
            positive_memory_turns: 0,
            care_plan_turns: 0
        },
        categories: [],
        scenarios: []
    };
    public rawData: any = {
        summary: {
            category_count: 0,
            scenario_count: 0,
            turn_count: 0,
            minimum_turns: 0,
            maximum_turns: 0
        },
        categories: [],
        scenarios: []
    };
    public followupData: any = {
        summary: {
            scenario_count: 0,
            question_count: 0,
            target_score: 85,
            score_label: '정보 충분도'
        },
        scenarios: []
    };
    public followupDrawerOpen: boolean = false;
    public followupAnswerState: any = {};
    public reevaluationMessage: string = '';
    public activeFollowup: any = null;
    public activeFollowupGroups: any[] = [];
    public activeGenerationQuestionId: string = '';
    public generationQuestionErrorId: string = '';
    public readonly phases: any[] = [
        {
            key: 'trauma_assessment',
            title: '외상·안전 문진',
            range: '1–30턴',
            description: '사건 경험과 현재 반응, 응급 위험과 지지 자원을 차분히 확인합니다.',
            icon: 'fa-stethoscope'
        },
        {
            key: 'positive_memory',
            title: '행복 기억 탐색',
            range: '31–48턴',
            description: '의료진이 전환을 제안하고 장면·감각·관계·감정·의미를 순차적으로 불러옵니다.',
            icon: 'fa-sun'
        },
        {
            key: 'care_plan',
            title: '진료·지원 계획',
            range: '49–50턴',
            description: '면담 내용을 요약하고 다음 평가·지원 방향을 합의합니다.',
            icon: 'fa-clipboard-check'
        }
    ];
    public readonly promptMedia: any[] = [
        { key: 'image', label: '이미지', icon: 'fa-image' },
        { key: 'audio', label: '오디오', icon: 'fa-wave-square' },
        { key: 'video', label: '영상', icon: 'fa-film' }
    ];
    private copyResetTimer: any = null;
    private previousBodyOverflow: string = '';
    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow('/access');
        window.addEventListener('ptsd:agent:scenario-imported', this.onAgentScenarioImported);
        window.addEventListener('ptsd:agent:scenario-import-ready', this.onAgentScenarioImportReady);
        window.addEventListener('ptsd:agent:page-context', this.onAgentPageContext);
        await this.load();
        const importJobId = new URLSearchParams(location.search).get('import_job');
        if (importJobId) void this.openImportJob(importJobId);
    }

    public ngOnDestroy() {
        window.removeEventListener('ptsd:agent:scenario-imported', this.onAgentScenarioImported);
        window.removeEventListener('ptsd:agent:scenario-import-ready', this.onAgentScenarioImportReady);
        window.removeEventListener('ptsd:agent:page-context', this.onAgentPageContext);
        if (this.copyResetTimer) window.clearTimeout(this.copyResetTimer);
        this.closeScenarioUpload(false);
        this.unlockBodyScroll();
    }

    public can(permission: string) {
        const permissions = this.service.auth?.session?.permissions;
        return Array.isArray(permissions) && permissions.includes(permission);
    }

    public async load() {
        this.loading = true;
        this.errorMessage = '';
        await this.service.render();
        try {
            const [response, rawResponse, followupResponse, generatedFollowupResponse] = await Promise.all([
                fetch('/assets/data/scenario-sets.json', { cache: 'no-store' }),
                fetch('/assets/data/raw-scenario-sets.json', { cache: 'no-store' }),
                fetch('/assets/data/raw-content-gap-analysis.json', { cache: 'no-store' }),
                fetch('/assets/data/generated-scenario-completions.json', { cache: 'no-store' })
            ]);
            if (!response.ok || !rawResponse.ok || !followupResponse.ok || !generatedFollowupResponse.ok) {
                throw new Error(`HTTP ${response.status}/${rawResponse.status}/${followupResponse.status}/${generatedFollowupResponse.status}`);
            }
            const [payload, rawPayload, followupPayload, generatedFollowupPayload] = await Promise.all([
                response.json(),
                rawResponse.json(),
                followupResponse.json(),
                generatedFollowupResponse.json()
            ]);
            if (!Array.isArray(payload?.scenarios) || payload.scenarios.length !== 28) {
                throw new Error('시나리오 데이터 형식이 올바르지 않습니다.');
            }
            if (!Array.isArray(rawPayload?.scenarios) || rawPayload.scenarios.length !== 28) {
                throw new Error('raw 시나리오 데이터 형식이 올바르지 않습니다.');
            }
            if (!Array.isArray(followupPayload?.scenarios) || followupPayload.scenarios.length !== 28) {
                throw new Error('추가 질문 데이터 형식이 올바르지 않습니다.');
            }
            if (!Array.isArray(generatedFollowupPayload?.scenarios) || generatedFollowupPayload.scenarios.length !== 28) {
                throw new Error('가공 시나리오 보완 데이터 형식이 올바르지 않습니다.');
            }
            this.data = payload;
            let uploaded: any[] = [];
            try {
                const uploadedResponse: any = await wiz.call('list_uploaded_scenarios', {});
                const uploadedResult = uploadedResponse?.responseJSON || uploadedResponse || {};
                if (uploadedResult.code === 200 && Array.isArray(uploadedResult.data?.items)) {
                    uploaded = uploadedResult.data.items;
                }
            } catch (_error) {
                // The bundled catalog stays available if the upload service is temporarily unavailable.
            }
            this.rawData = {
                ...rawPayload,
                summary: {
                    ...rawPayload.summary,
                    scenario_count: rawPayload.scenarios.length + uploaded.length
                },
                scenarios: [...rawPayload.scenarios, ...uploaded]
            };
            this.followupData = {
                ...followupPayload,
                scenarios: [...generatedFollowupPayload.scenarios, ...followupPayload.scenarios]
            };
            const params = new URLSearchParams(location.search);
            const requestedId = params.get('scenario');
            const requestedSource = params.get('source');
            const requestedUpload = params.get('upload');
            const uploadedScenario = uploaded.find((item: any) => item.uploaded_id === requestedUpload);
            const requestedRaw = this.rawData.scenarios.find(
                (item: any) => item.id === requestedId && !item.uploaded_id
            );
            const requestedGenerated = this.showGeneratedSets && payload.scenarios.find(
                (item: any) => item.id === requestedId
            );
            this.selectedScenario = uploadedScenario || (requestedSource === 'generated'
                ? requestedGenerated || requestedRaw || rawPayload.scenarios[0]
                : requestedRaw || requestedGenerated || rawPayload.scenarios[0]);
            const selectedIndex = this.filteredRawScenarios().findIndex(
                (item: any) => this.selectionKey(item) === this.selectionKey(this.selectedScenario)
            );
            this.scenarioPage = selectedIndex < 0
                ? 1
                : Math.floor(selectedIndex / this.scenarioPageSize) + 1;
            if (!this.showGeneratedSets && requestedId && !requestedRaw && !uploadedScenario && this.selectedScenario) {
                const url = new URL(location.href);
                url.searchParams.set('scenario', this.selectedScenario.id);
                url.searchParams.set('source', 'raw');
                history.replaceState({}, '', `${url.pathname}${url.search}`);
            }
        } catch (_error) {
            this.errorMessage = '시나리오 세트를 불러오지 못했습니다. 새로고침 후 다시 시도해 주세요.';
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }

    private filterScenarios(scenarios: any[]) {
        const query = this.searchText.trim().toLocaleLowerCase();
        return (scenarios || []).filter((item: any) => {
            if (this.selectedCategory !== 'all' && item.category_key !== this.selectedCategory) return false;
            if (!query) return true;
            const haystack = [item.id, item.title].join(' ').toLocaleLowerCase();
            return haystack.includes(query);
        });
    }

    public filteredScenarios() {
        return this.filterScenarios(this.data.scenarios || []);
    }

    public filteredRawScenarios() {
        return this.filterScenarios(this.rawData.scenarios || []);
    }

    public pagedRawScenarios() {
        const start = (this.scenarioPage - 1) * this.scenarioPageSize;
        return this.filteredRawScenarios().slice(start, start + this.scenarioPageSize);
    }

    public scenarioPageCount() {
        return Math.max(1, Math.ceil(this.filteredRawScenarios().length / this.scenarioPageSize));
    }

    public scenarioPageNumbers() {
        const count = this.scenarioPageCount();
        const length = Math.min(7, count);
        const start = Math.max(1, Math.min(this.scenarioPage - 3, count - length + 1));
        return Array.from({ length }, (_item, index) => start + index);
    }

    public async changeScenarioPage(page: number) {
        if (page < 1 || page > this.scenarioPageCount() || page === this.scenarioPage) return;
        this.scenarioPage = page;
        const first = this.pagedRawScenarios()[0];
        if (first) await this.selectScenario(first);
        else await this.service.render();
    }

    public selectDetailTab(tab: 'overview' | 'dialogue' | 'elements') {
        this.activeDetailTab = tab;
        void this.service.render();
    }

    public openScenarioUpload() {
        if (!this.can('content.write')) return;
        this.scenarioUploadReturnFocus = document.activeElement instanceof HTMLElement
            ? document.activeElement : null;
        this.scenarioImportPreview = null;
        this.scenarioImportError = '';
        this.scenarioImportNotice = '';
        this.scenarioImportExistingUploadId = '';
        this.scenarioImportFile = null;
        this.scenarioImportJob = null;
        this.scenarioImportStatus = '';
        this.scenarioUploadOpen = true;
        void this.service.render().then(() => {
            document.getElementById('scenario-import-file')?.focus();
        });
    }

    public closeScenarioUpload(restoreFocus: boolean = true) {
        if (this.scenarioImportSaving) return;
        if (this.scenarioImportJob?.committed) {
            const url = new URL(location.href);
            url.searchParams.delete('import_job');
            history.replaceState({}, '', `${url.pathname}${url.search}`);
        }
        this.scenarioUploadOpen = false;
        this.scenarioImportPreview = null;
        this.scenarioImportError = '';
        this.scenarioImportNotice = '';
        this.scenarioImportExistingUploadId = '';
        this.scenarioImportFile = null;
        this.scenarioImportJob = null;
        this.scenarioImportStatus = '';
        if (restoreFocus) void this.service.render().then(() => this.scenarioUploadReturnFocus?.focus());
        this.scenarioUploadReturnFocus = null;
    }

    public onScenarioUploadKeydown(event: KeyboardEvent) {
        if (event.key === 'Escape' && !this.scenarioImportSaving) {
            event.preventDefault();
            this.closeScenarioUpload();
        }
    }

    public async onScenarioImportFile(event: Event) {
        const input = event.target as HTMLInputElement;
        const file = input.files?.[0];
        this.scenarioImportPreview = null;
        this.scenarioImportFile = null;
        this.scenarioImportError = '';
        this.scenarioImportNotice = '';
        this.scenarioImportExistingUploadId = '';
        if (!file) return;
        if (!/\.(json|xlsx|pdf|md|txt|csv|docx|hwp|hwpx|png|jpe?g|webp)$/i.test(file.name) || !file.size || file.size > 8_000_000) {
            this.scenarioImportError = 'JSON, XLSX, PDF, MD, TXT, CSV, DOCX, HWP/HWPX 또는 이미지 파일(8MB 이하)을 선택해주세요.';
            await this.service.render();
            return;
        }
        this.scenarioImportFile = file;
        this.scenarioImportPreview = { title: file.name, description: '파일을 읽고 Codex가 시나리오별로 분석합니다. 검토 후 등록됩니다.' };
        await this.service.render();
    }

    private async importRequest(path: string, payload: FormData): Promise<any> {
        payload.append('csrf_token', this.service.auth?.session?.csrf_token || '');
        const response = await fetch(`/api/ptsd/codex/scenario-import${path}`, {
            method: 'POST', body: payload, credentials: 'same-origin'
        });
        const result = await response.json();
        if (result.code !== 200) throw new Error(result.data?.message || '시나리오 분석을 완료하지 못했습니다.');
        return result.data;
    }

    public async openImportJob(jobId: string) {
        try {
            const response = await fetch(`/api/ptsd/codex/scenario-import/status?job_id=${encodeURIComponent(jobId)}`, {
                credentials: 'same-origin'
            });
            const result = await response.json();
            if (result.code !== 200) throw new Error(result.data?.message || '분석 작업을 찾을 수 없습니다.');
            await this.showImportReview(result.data);
        } catch (error: any) {
            this.scenarioImportError = error?.message || '분석 작업을 찾을 수 없습니다.';
            this.scenarioUploadOpen = true;
            await this.service.render();
        }
    }

    private async showImportReview(job: any) {
        this.scenarioImportJob = job;
        this.scenarioImportSelected = 0;
        this.scenarioImportError = '';
        this.scenarioImportNotice = '';
        this.scenarioImportExistingUploadId = '';
        this.scenarioUploadOpen = true;
        this.scenarioImportStatus = job.ready ? '분석 완료 · 내용을 확인하고 등록하세요.'
            : `${job.analyzed}/${job.count}개 분석 완료`;
        await this.service.render();
    }

    public selectImportScenario(index: number) {
        this.scenarioImportSelected = index;
        void this.service.render();
    }

    public async saveImportedScenario() {
        if (this.scenarioImportSaving || (!this.scenarioImportFile && !this.scenarioImportJob)) return;
        this.scenarioImportSaving = true;
        this.scenarioImportError = '';
        this.scenarioImportNotice = '';
        await this.service.render();
        try {
            if (!this.scenarioImportJob) {
                const payload = new FormData();
                payload.append('attachments[]', this.scenarioImportFile!, this.scenarioImportFile!.name);
                this.scenarioImportStatus = '파일 구조와 대화를 확인하는 중';
                await this.service.render();
                this.scenarioImportJob = await this.importRequest('', payload);
                const url = new URL(location.href);
                url.searchParams.set('import_job', this.scenarioImportJob.job_id);
                history.replaceState({}, '', `${url.pathname}${url.search}`);
            }
            while (!this.scenarioImportJob.ready) {
                const job = this.scenarioImportJob;
                const current = job.scenarios[job.analyzed];
                this.scenarioImportStatus = `${job.analyzed + 1}/${job.count} · ${current?.title || '시나리오'} 분석 중`;
                await this.service.render();
                const payload = new FormData();
                payload.append('job_id', job.job_id);
                this.scenarioImportJob = await this.importRequest('/analyze-next', payload);
            }
            this.scenarioImportStatus = '분석 완료 · 사건·인물 정보와 근거를 검토한 뒤 등록하세요.';
            if (!this.scenarioImportJob.committed && this.scenarioImportJob.scenarios.length) {
                this.scenarioImportSaving = false;
                await this.service.render();
                return;
            }
            const items = this.scenarioImportJob.result?.items || [];
            if (!items.length) throw new Error('등록 결과를 확인할 수 없습니다.');
            await this.finishImport(items);
        } catch (error: any) {
            this.scenarioImportError = error?.message || '시나리오를 분석하지 못했습니다.';
            this.scenarioImportSaving = false;
            await this.service.render();
        }
    }

    public async commitImportedScenarios() {
        if (!this.scenarioImportJob?.ready || this.scenarioImportSaving) return;
        this.scenarioImportSaving = true;
        this.scenarioImportError = '';
        this.scenarioImportStatus = '검토한 시나리오를 등록하는 중';
        await this.service.render();
        try {
            const payload = new FormData();
            payload.append('job_id', this.scenarioImportJob.job_id);
            payload.append('edits', JSON.stringify(this.scenarioImportJob.scenarios.map((item: any) => ({
                generation_basis: item.generation_basis, design_notes: item.design_notes
            }))));
            const result = await this.importRequest('/commit', payload);
            this.scenarioImportJob.committed = true;
            await this.finishImport(result.items || []);
        } catch (error: any) {
            this.scenarioImportError = error?.message || '시나리오를 등록하지 못했습니다.';
            this.scenarioImportSaving = false;
            await this.service.render();
        }
    }

    private async finishImport(items: any[]) {
            if (!items.length) throw new Error('등록 결과를 확인할 수 없습니다.');
            if (items.every((item: any) => item.already_exists)) {
                this.scenarioImportSaving = false;
                this.scenarioImportNotice = `이 파일의 시나리오 ${items.length}개는 이미 등록되어 있습니다. 새로 저장하지 않았습니다.`;
                this.scenarioImportExistingUploadId = String(items[0].uploaded_id || '');
                await this.service.render();
                return;
            }
            const uploadId = items.find((item: any) => !item.already_exists)?.uploaded_id || items[0].uploaded_id;
            this.scenarioImportSaving = false;
            this.closeScenarioUpload();
            window.dispatchEvent(new CustomEvent('ptsd:scenario:library-changed'));
            const url = new URL(location.href);
            url.searchParams.delete('import_job');
            history.replaceState({}, '', `${url.pathname}${url.search}`);
            await this.showUploadedScenario(String(uploadId));
    }

    public async openExistingScenario() {
        const uploadId = this.scenarioImportExistingUploadId;
        if (!uploadId) return;
        this.closeScenarioUpload();
        await this.showUploadedScenario(uploadId);
    }

    private async showUploadedScenario(uploadId: string) {
        this.searchText = '';
        this.selectedCategory = 'all';
        const url = new URL(location.href);
        url.searchParams.delete('import_job');
        url.searchParams.set('upload', uploadId);
        history.replaceState({}, '', `${url.pathname}${url.search}`);
        await this.load();
    }

    public selectCategory(key: string) {
        this.selectedCategory = key;
        this.scenarioPage = 1;
        this.ensureVisibleSelection();
        void this.service.render();
    }

    public onSearchChange() {
        this.scenarioPage = 1;
        this.ensureVisibleSelection();
        void this.service.render();
    }

    public clearFilters() {
        this.searchText = '';
        this.selectedCategory = 'all';
        this.scenarioPage = 1;
        this.ensureVisibleSelection();
        void this.service.render();
    }

    private ensureVisibleSelection() {
        const previousKey = this.selectionKey(this.selectedScenario);
        const visible = this.showGeneratedSets
            ? [...this.filteredScenarios(), ...this.filteredRawScenarios()]
            : this.filteredRawScenarios();
        let selectedIndex = visible.findIndex(
            (item: any) => this.selectionKey(item) === this.selectionKey(this.selectedScenario)
        );
        if (selectedIndex < 0) {
            this.selectedScenario = visible[0] || null;
            selectedIndex = this.selectedScenario ? 0 : -1;
        }
        this.scenarioPage = selectedIndex < 0 ? 1 : Math.floor(selectedIndex / this.scenarioPageSize) + 1;
        if (previousKey !== this.selectionKey(this.selectedScenario)) {
            if (this.followupDrawerOpen) this.closeDrawerState();
            this.activeDetailTab = 'overview';
            if (this.selectedScenario) {
                const url = new URL(location.href);
                url.searchParams.set('scenario', this.selectedScenario.id);
                if (this.selectedScenario.uploaded_id) url.searchParams.set('upload', this.selectedScenario.uploaded_id);
                else url.searchParams.delete('upload');
                url.searchParams.set('source', 'raw');
                history.replaceState({}, '', `${url.pathname}${url.search}`);
            }
        }
    }

    public async selectScenario(item: any) {
        if (this.followupDrawerOpen) this.closeDrawerState();
        this.selectedScenario = item;
        this.activeDetailTab = 'overview';
        const url = new URL(location.href);
        url.searchParams.set('scenario', item.id);
        if (item.uploaded_id) url.searchParams.set('upload', item.uploaded_id);
        else url.searchParams.delete('upload');
        if (item.source === 'raw') url.searchParams.set('source', 'raw');
        else url.searchParams.delete('source');
        history.replaceState({}, '', `${url.pathname}${url.search}`);
        await this.service.render();
        if (window.matchMedia('(max-width: 1279px)').matches) {
            window.setTimeout(() => {
                document.getElementById('scenario-detail')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }, 0);
        }
    }

    public async exportSelectedScenario(format: 'json' | 'csv') {
        if (!this.selectedScenario || this.scenarioExporting) return;
        if (format !== 'json' && format !== 'csv') return;
        this.scenarioExporting = format;
        await this.service.render();
        try {
            const scenario = this.selectedScenario;
            const source = this.isRawScenario() ? 'raw' : 'generated';
            const safeId = String(scenario.id || 'scenario')
                .replace(/[^a-zA-Z0-9_-]+/g, '-')
                .replace(/^-+|-+$/g, '') || 'scenario';
            const filename = `ptsd-scenario-${safeId}-${source}.${format}`;
            if (format === 'json') {
                const payload = {
                    schema: 'ptsd-scenario-export',
                    schema_version: 1,
                    catalog_version: Number(
                        (this.isRawScenario() ? this.rawData : this.data)?.version || 1
                    ),
                    source,
                    exported_at: new Date().toISOString(),
                    scenario
                };
                this.downloadScenarioFile(
                    JSON.stringify(payload, null, 2) + '\n',
                    filename,
                    'application/json;charset=utf-8'
                );
            } else {
                this.downloadScenarioFile(
                    '\ufeff' + this.scenarioCsv(scenario, source),
                    filename,
                    'text/csv;charset=utf-8'
                );
            }
        } catch (_error) {
            await this.service.modal.error('시나리오 파일을 내보내지 못했습니다. 다시 시도해 주세요.');
        } finally {
            this.scenarioExporting = '';
            await this.service.render();
        }
    }

    private scenarioCsv(scenario: any, source: string) {
        const columns = [
            'scenario_id',
            'source',
            'source_file',
            'source_sheet',
            'category_key',
            'category_label',
            'title',
            'incident_type',
            'incident_year',
            'incident_period',
            'exposure_type',
            'age_band',
            'gender',
            'role',
            'life_context',
            'speech_characteristic',
            'turn',
            'phase',
            'speaker',
            'speaker_label',
            'text',
            'label',
            'purpose',
            'signals'
        ];
        const profile = scenario?.generation_basis || {};
        const common: any = {
            scenario_id: scenario?.id,
            source,
            source_file: scenario?.source_file,
            source_sheet: scenario?.source_sheet,
            category_key: scenario?.category_key,
            category_label: scenario?.category_label,
            title: scenario?.title,
            incident_type: profile.incident_type,
            incident_year: profile.incident_year,
            incident_period: profile.incident_period,
            exposure_type: profile.exposure_type,
            age_band: profile.age_band,
            gender: profile.gender,
            role: profile.role,
            life_context: profile.life_context,
            speech_characteristic: profile.speech_characteristic
        };
        const dialogue = Array.isArray(scenario?.dialogue) ? scenario.dialogue : [];
        const rows = dialogue.map((turn: any) => ({
            ...common,
            turn: turn?.turn,
            phase: turn?.phase,
            speaker: turn?.speaker,
            speaker_label: turn?.speaker_label,
            text: turn?.text,
            label: turn?.label,
            purpose: turn?.purpose,
            signals: turn?.signals
        }));
        const outputRows = rows.length ? rows : [common];
        return [
            columns.map((column: string) => this.csvCell(column)).join(','),
            ...outputRows.map((row: any) => (
                columns.map((column: string) => this.csvCell(row[column])).join(',')
            ))
        ].join('\r\n') + '\r\n';
    }

    private csvCell(value: any) {
        let text = value === null || value === undefined ? '' : String(value);
        // Prevent spreadsheet applications from interpreting exported text as formulas.
        if (/^[\u0000-\u0020]*[=+\-@]/.test(text)) text = "'" + text;
        return `"${text.replace(/"/g, '""')}"`;
    }

    private downloadScenarioFile(content: string, filename: string, contentType: string) {
        const blob = new Blob([content], { type: contentType });
        const url = URL.createObjectURL(blob);
        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.download = filename;
        anchor.rel = 'noopener';
        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);
        window.setTimeout(() => URL.revokeObjectURL(url), 0);
    }

    public categoryCount(key: string) {
        const scenarios = this.showGeneratedSets
            ? [...(this.data.scenarios || []), ...(this.rawData.scenarios || [])]
            : (this.rawData.scenarios || []);
        if (key === 'all') return scenarios.length;
        return scenarios.filter((item: any) => item.category_key === key).length;
    }

    public dialogueFor(phase: string) {
        if (!this.selectedScenario) return [];
        return (this.selectedScenario.dialogue || []).filter((turn: any) => turn.phase === phase);
    }

    public generationBasisRows() {
        const profile = this.selectedScenario?.generation_basis || {};
        return [
            { label: '사건 유형', value: profile.incident_type },
            { label: '사건 발생 연도', value: profile.incident_period ? `${profile.incident_period} (${profile.incident_decade})` : '' },
            { label: '연령대', value: profile.age_band },
            { label: '성별', value: profile.gender },
            { label: '당시 역할', value: profile.role },
            { label: '생활 맥락', value: profile.life_context },
            { label: '말하기 특징', value: profile.speech_characteristic }
        ].filter((item: any) => !!item.value);
    }

    public generationBasisGroups() {
        const profile = this.selectedScenario?.generation_basis || {};
        if (this.isRawScenario()) {
            return [
                {
                    key: 'event',
                    title: '사건 정보',
                    description: '원본에 기록된 사건의 종류와 발생 시점',
                    icon: 'fa-calendar-days',
                    rows: [
                        { label: '시나리오', value: profile.incident_type },
                        { label: '발생 연도', value: profile.incident_period ? `${profile.incident_period} (${profile.incident_decade})` : '' },
                        { label: '노출 방식', value: profile.exposure_type }
                    ]
                },
                {
                    key: 'person',
                    title: '인물 정보',
                    description: '원본 대화 속 환자의 특성',
                    icon: 'fa-user',
                    rows: [
                        { label: '현재 나이', value: profile.current_age || profile.age_band },
                        { label: '사건 당시', value: profile.age_at_incident },
                        { label: '성별', value: profile.gender },
                        { label: '역할·맥락', value: profile.role }
                    ]
                },
                {
                    key: 'dialogue',
                    title: '대화 맥락',
                    description: '원본에 지정된 진술 방식',
                    icon: 'fa-comments',
                    rows: [
                        { label: '진술 스타일', value: profile.speech_characteristic }
                    ]
                }
            ].map((group: any) => ({
                ...group,
                rows: group.rows.filter((row: any) => !!row.value)
            }));
        }
        return [
            {
                key: 'event',
                title: '사건 정보',
                description: '사건의 종류와 발생 시점',
                icon: 'fa-calendar-days',
                rows: [
                    { label: '사건 유형', value: profile.incident_type },
                    { label: '발생 연도', value: profile.incident_period ? `${profile.incident_period} (${profile.incident_decade})` : '' }
                ]
            },
            {
                key: 'person',
                title: '인물 정보',
                description: '대화 속 환자의 기본 특성',
                icon: 'fa-user',
                rows: [
                    { label: '연령대', value: profile.age_band },
                    { label: '성별', value: profile.gender },
                    { label: '당시 역할', value: profile.role }
                ]
            },
            {
                key: 'dialogue',
                title: '대화 맥락',
                description: '생활 배경과 응답 표현 방식',
                icon: 'fa-comments',
                rows: [
                    { label: '생활 맥락', value: profile.life_context },
                    { label: '말하기 특징', value: profile.speech_characteristic }
                ]
            }
        ].map((group: any) => ({
            ...group,
            rows: group.rows.filter((row: any) => !!row.value)
        }));
    }

    public generationBasisCount() {
        return this.generationBasisGroups().reduce((total: number, group: any) => total + group.rows.length, 0);
    }

    public isRawScenario() {
        return this.selectedScenario?.source === 'raw';
    }

    public selectedFollowup() {
        return this.followupForScenario(this.selectedScenario);
    }

    public followupForScenario(scenario: any) {
        if (!scenario?.id || scenario.uploaded_id) return null;
        return (this.followupData.scenarios || []).find((item: any) => item.id === scenario.id) || null;
    }

    public isCompletedRawScenario(scenario: any) {
        return this.followupForScenario(scenario)?.completion?.status === '보완 완료';
    }

    public followupDisplayScore(followup: any) {
        return Number(followup?.completion?.completed_score ?? followup?.current_score ?? 0);
    }

    public isMediaGenerationFollowup(followup: any = null) {
        const target = followup || this.activeFollowup || this.selectedFollowup();
        return target?.question_mode === 'content-gap-v2' || target?.question_mode === 'media-generation-gap-v1';
    }

    public isMediaGenerationScenario(scenario: any) {
        return this.isMediaGenerationFollowup(this.followupForScenario(scenario));
    }

    public knownGenerationInformation() {
        const rows = this.activeFollowup?.generation_analysis?.known_information;
        return Array.isArray(rows) ? rows : [];
    }

    public generationReadinessDefinition() {
        const followup = this.activeFollowup || this.selectedFollowup();
        return followup?.generation_readiness || null;
    }

    public generationReadinessScore() {
        const definition = this.generationReadinessDefinition();
        if (!definition) return 0;
        const questions = (this.activeFollowup || this.selectedFollowup())?.questions || [];
        const answeredGain = questions.reduce((total: number, question: any) => {
            if (!this.questionHasRecordedAnswer(question)) return total;
            return total + Number(question?.readiness_gain || 0);
        }, 0);
        return Math.min(100, Number(definition.base_score || 0) + answeredGain);
    }

    public generationReadinessTarget() {
        return Number(this.generationReadinessDefinition()?.target_score || 85);
    }

    public generationConsentGranted() {
        const question = ((this.activeFollowup || this.selectedFollowup())?.questions || [])
            .find((item: any) => item.gate_id === 'generation_consent');
        return !!question && this.questionState(question).status === 'present';
    }

    public generationConsentDenied() {
        const question = ((this.activeFollowup || this.selectedFollowup())?.questions || [])
            .find((item: any) => item.gate_id === 'generation_consent');
        return !!question && this.questionState(question).status === 'absent';
    }

    public missingRequiredGenerationQuestions() {
        return ((this.activeFollowup || this.selectedFollowup())?.questions || [])
            .filter((question: any) => question.required_for_generation)
            .filter((question: any) => {
                if (question.gate_id === 'generation_consent') return !this.generationConsentGranted();
                return !this.questionHasRecordedAnswer(question);
            });
    }

    public generationReady() {
        const definition = this.generationReadinessDefinition();
        if (!definition || this.generationConsentDenied()) return false;
        return this.generationConsentGranted()
            && this.missingRequiredGenerationQuestions().length === 0
            && this.generationReadinessScore() >= this.generationReadinessTarget();
    }

    public generationReadinessLabel() {
        if (this.generationConsentDenied()) return '생성하지 않음';
        if (this.generationReady()) return '생성 가능';
        return '추가 확인 필요';
    }

    public generationQuestionPartLabel(question: any) {
        return question?.section === 'cut' ? '콘텐츠 구성' : '추가 확인';
    }

    public followupGroups() {
        return this.buildFollowupGroups(this.selectedFollowup()?.questions || []);
    }

    private buildFollowupGroups(questions: any[]) {
        if (this.isMediaGenerationFollowup()) {
            const generationMetadata: any[] = [
                {
                    key: '핵심',
                    title: '제작 동의',
                    description: '대화 내용을 이미지나 영상으로 표현해도 괜찮은지 먼저 확인합니다.',
                    icon: 'fa-hand',
                    tone: 'required'
                },
                {
                    key: '표현',
                    title: '신원 보호',
                    description: '얼굴·이름·연락처 등 개인을 알아볼 수 있는 정보의 보호 범위를 확인합니다.',
                    icon: 'fa-user-shield',
                    tone: 'supplemental'
                },
                {
                    key: '보호',
                    title: '제외할 내용',
                    description: '원하지 않는 장면·소리·식별 요소를 생성 전에 제외합니다.',
                    icon: 'fa-shield-heart',
                    tone: 'consent'
                }
            ];
            return generationMetadata
                .map((group: any) => ({
                    ...group,
                    questions: questions.filter((question: any) => question.priority === group.key)
                }))
                .filter((group: any) => group.questions.length > 0);
        }
        const metadata: any[] = [
            {
                key: '면담 전',
                title: '면담 전 확인',
                description: '질문 동의와 중단·건너뛰기 선택권을 먼저 확인합니다.',
                icon: 'fa-hand',
                tone: 'consent'
            },
            {
                key: '즉시',
                title: '즉시 안전 확인',
                description: '현재 위험이 확인되면 다른 질문보다 기관 위기대응 절차를 우선합니다.',
                icon: 'fa-shield-heart',
                tone: 'safety'
            },
            {
                key: '필수',
                title: '필수 보완 질문',
                description: 'PTSD 반응과 기능, 감별에 필요한 핵심 누락 정보를 확인합니다.',
                icon: 'fa-list-check',
                tone: 'required'
            },
            {
                key: '보완',
                title: '보완 질문',
                description: '행복 기억의 구체성과 접근성을 더 분명하게 확인합니다.',
                icon: 'fa-sun',
                tone: 'supplemental'
            }
        ];
        return metadata
            .map((group: any) => ({
                ...group,
                questions: questions.filter((question: any) => question.priority === group.key)
            }))
            .filter((group: any) => group.questions.length > 0);
    }

    public openFollowupDrawer() {
        const followup = this.selectedFollowup();
        if (!followup) return;
        this.activeFollowup = followup;
        this.activeFollowupGroups = this.isMediaGenerationFollowup(followup)
            ? []
            : this.buildFollowupGroups(followup.questions || []);
        const scenarioId = this.selectedScenario?.id || '';
        const scenarioState = { ...(this.followupAnswerState[scenarioId] || {}) };
        const completedAnswers = this.isMediaGenerationFollowup(followup) ? {} : (followup.completion?.answers || {});
        for (const question of followup.questions || []) {
            if (!scenarioState[question.id]) {
                const completed = completedAnswers[question.id];
                scenarioState[question.id] = completed
                    ? { status: completed.status, note: completed.note }
                    : { status: 'unanswered', note: '' };
            }
        }
        this.followupAnswerState = { ...this.followupAnswerState, [scenarioId]: scenarioState };
        const firstGenerationQuestion = (followup.questions || []).find(
            (question: any) => scenarioState[question.id]?.status === 'unanswered'
        ) || (followup.questions || [])[0];
        this.activeGenerationQuestionId = this.isMediaGenerationFollowup(followup)
            ? firstGenerationQuestion?.id || ''
            : '';
        this.generationQuestionErrorId = '';
        this.followupDrawerOpen = true;
        this.reevaluationMessage = '';
        this.previousBodyOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        void this.service.render();
        window.setTimeout(() => {
            document.querySelector<HTMLElement>('#scenario-followup-drawer .scenario-drawer-close')?.focus();
        }, 0);
    }

    public closeFollowupDrawer(restoreFocus: boolean = true) {
        if (!this.followupDrawerOpen) return;
        this.closeDrawerState();
        void this.service.render();
        if (restoreFocus) {
            window.setTimeout(() => document.getElementById('scenario-followup-trigger')?.focus(), 0);
        }
    }

    private closeDrawerState() {
        this.followupDrawerOpen = false;
        this.activeFollowup = null;
        this.activeFollowupGroups = [];
        this.activeGenerationQuestionId = '';
        this.generationQuestionErrorId = '';
        this.reevaluationMessage = '';
        this.unlockBodyScroll();
    }

    private unlockBodyScroll() {
        if (typeof document === 'undefined') return;
        document.body.style.overflow = this.previousBodyOverflow;
        this.previousBodyOverflow = '';
    }

    public onDrawerKeydown(event: KeyboardEvent) {
        if (event.key === 'Escape') {
            event.preventDefault();
            this.closeFollowupDrawer();
            return;
        }
        if (event.key !== 'Tab') return;
        const drawer = document.getElementById('scenario-followup-drawer');
        const focusable = Array.from(drawer?.querySelectorAll<HTMLElement>(
            'button:not([disabled]), textarea:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
        ) || []).filter((element: HTMLElement) => element.offsetParent !== null);
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
        }
    }

    public questionState(question: any) {
        const scenarioId = this.selectedScenario?.id || '';
        return this.followupAnswerState[scenarioId]?.[question?.id] || this.emptyQuestionState;
    }

    public setQuestionStatus(question: any, status: 'unanswered' | 'present' | 'absent' | 'deferred') {
        const scenarioId = this.selectedScenario?.id;
        if (!scenarioId || !question?.id) return;
        const scenarioState = this.followupAnswerState[scenarioId] || {};
        const current = scenarioState[question.id] || { status: 'unanswered', note: '' };
        this.followupAnswerState = {
            ...this.followupAnswerState,
            [scenarioId]: {
                ...scenarioState,
                [question.id]: { ...current, status }
            }
        };
        this.reevaluationMessage = '';
        void this.service.render();
    }

    public updateQuestionNote(question: any, note: string) {
        const scenarioId = this.selectedScenario?.id;
        if (!scenarioId || !question?.id) return;
        const scenarioState = this.followupAnswerState[scenarioId] || {};
        const current = scenarioState[question.id] || { status: 'unanswered', note: '' };
        this.followupAnswerState = {
            ...this.followupAnswerState,
            [scenarioId]: {
                ...scenarioState,
                [question.id]: { ...current, note }
            }
        };
        if (String(note || '').trim() && this.generationQuestionErrorId === question.id) {
            this.generationQuestionErrorId = '';
        }
    }

    public isGenerationQuestionExpanded(question: any) {
        return this.activeGenerationQuestionId === question?.id;
    }

    public toggleGenerationQuestion(question: any) {
        if (!question?.id) return;
        this.activeGenerationQuestionId = this.isGenerationQuestionExpanded(question) ? '' : question.id;
        this.generationQuestionErrorId = '';
        this.reevaluationMessage = '';
        void this.service.render();
        if (this.activeGenerationQuestionId) this.focusGenerationAnswer(question.id);
    }

    public saveGenerationAnswer(question: any) {
        if (!String(this.questionState(question).note || '').trim()) {
            this.generationQuestionErrorId = question?.id || '';
            void this.service.render();
            this.focusGenerationAnswer(question?.id || '');
            return;
        }
        this.generationQuestionErrorId = '';
        this.setQuestionStatus(question, 'present');
    }

    public recordGenerationConsent(question: any, granted: boolean) {
        const scenarioId = this.selectedScenario?.id;
        if (!scenarioId || !question?.id) return;
        const scenarioState = this.followupAnswerState[scenarioId] || {};
        this.followupAnswerState = {
            ...this.followupAnswerState,
            [scenarioId]: {
                ...scenarioState,
                [question.id]: {
                    status: granted ? 'present' : 'absent',
                    note: granted
                        ? '이미지·영상 제작에 동의함'
                        : '이미지·영상 제작에 동의하지 않음'
                }
            }
        };
        this.generationQuestionErrorId = '';
        if (granted) {
            this.openNextGenerationQuestion(question);
        } else {
            this.reevaluationMessage = '환자가 이미지·영상 제작에 동의하지 않아 생성 단계로 진행하지 않습니다.';
            void this.service.render();
        }
    }

    public deferGenerationConsent(question: any) {
        const scenarioId = this.selectedScenario?.id;
        if (!scenarioId || !question?.id) return;
        const scenarioState = this.followupAnswerState[scenarioId] || {};
        this.followupAnswerState = {
            ...this.followupAnswerState,
            [scenarioId]: {
                ...scenarioState,
                [question.id]: {
                    status: 'deferred',
                    note: '이미지·영상 제작 동의를 나중에 다시 확인하기로 함'
                }
            }
        };
        this.activeGenerationQuestionId = question.id;
        this.reevaluationMessage = '제작 동의가 보류되어 이미지·영상 생성 단계로 진행하지 않습니다.';
        void this.service.render();
    }

    public skipGenerationQuestion(question: any) {
        this.generationQuestionErrorId = '';
        this.setQuestionStatus(question, 'deferred');
        this.openNextGenerationQuestion(question);
    }

    public generationFooterAction() {
        const followup = this.activeFollowup || this.selectedFollowup();
        const questions = followup?.questions || [];
        if (!questions.length) return;
        if (this.generationConsentDenied() || this.generationReady() || this.addressedQuestionCount() >= questions.length) {
            this.reevaluateFollowup();
            return;
        }
        const active = questions.find((question: any) => question.id === this.activeGenerationQuestionId);
        this.openNextGenerationQuestion(active);
    }

    public generationFooterLabel() {
        if (this.activeFollowup?.question_mode === 'content-gap-v2') {
            return this.addressedQuestionCount() >= (this.activeFollowup?.questions || []).length
                ? '실제 답변 기록 확인' : '실제 답변 입력';
        }
        if (this.generationConsentDenied()) return '생성하지 않음';
        if (this.generationReady()) return '생성 준비 완료';
        const count = (this.activeFollowup?.questions || []).length;
        return count > 0 && this.addressedQuestionCount() >= count
            ? '준비도 다시 확인'
            : '다음 질문';
    }

    private openNextGenerationQuestion(currentQuestion: any = null) {
        const questions = this.activeFollowup?.questions || [];
        if (!questions.length) return;
        const currentIndex = Math.max(0, questions.findIndex((question: any) => question.id === currentQuestion?.id));
        const ordered = [...questions.slice(currentIndex + 1), ...questions.slice(0, currentIndex + 1)];
        const next = ordered.find((question: any) => this.questionState(question).status === 'unanswered')
            || questions[(currentIndex + 1) % questions.length];
        this.activeGenerationQuestionId = next?.id || '';
        this.reevaluationMessage = '';
        void this.service.render();
        if (next?.id) this.focusGenerationAnswer(next.id);
    }

    private focusGenerationAnswer(questionId: string) {
        if (!questionId) return;
        window.setTimeout(() => {
            document.getElementById(`generation-answer-${questionId}`)?.focus();
        }, 0);
    }

    public answeredQuestionCount() {
        const questions = this.activeFollowup?.questions || this.selectedFollowup()?.questions || [];
        return questions.filter((question: any) => this.questionHasRecordedAnswer(question)).length;
    }

    public addressedQuestionCount() {
        const questions = this.activeFollowup?.questions || this.selectedFollowup()?.questions || [];
        return questions.filter((question: any) => this.questionState(question).status !== 'unanswered').length;
    }

    public questionHasRecordedAnswer(question: any) {
        const state = this.questionState(question);
        return ['present', 'absent'].includes(state.status) && String(state.note || '').trim().length > 0;
    }

    public questionNeedsAnswerNote(question: any) {
        const state = this.questionState(question);
        return ['present', 'absent'].includes(state.status) && !String(state.note || '').trim();
    }

    public questionCriteria(question: any) {
        const criterionIds = new Set(question?.criterion_ids || []);
        return (this.activeFollowup?.domains || [])
            .flatMap((domain: any) => (domain.criteria || []).map((criterion: any) => ({ ...criterion, domain_label: domain.label })))
            .filter((criterion: any) => criterionIds.has(criterion.id));
    }

    private linkedQuestion(criterionId: string) {
        return (this.activeFollowup?.questions || []).find((question: any) =>
            (question.criterion_ids || []).includes(criterionId)
        );
    }

    public criterionScore(criterion: any) {
        if (Number(criterion?.score) >= Number(criterion?.max_score)) return Number(criterion?.max_score || 0);
        const question = this.linkedQuestion(criterion?.id);
        return question && this.questionHasRecordedAnswer(question)
            ? Number(criterion?.max_score || 0)
            : Number(criterion?.score || 0);
    }

    public criterionStatus(criterion: any) {
        if (Number(criterion?.score) >= Number(criterion?.max_score)) return '기록 충족';
        const question = this.linkedQuestion(criterion?.id);
        if (question && this.questionHasRecordedAnswer(question)) return '답변 반영';
        return `${Number(criterion?.deduction || 0)}점 감점`;
    }

    public criterionReason(criterion: any) {
        if (Number(criterion?.score) < Number(criterion?.max_score)) {
            const question = this.linkedQuestion(criterion?.id);
            if (question && this.questionHasRecordedAnswer(question)) {
                return '추가 질문의 명시적 답변과 근거 메모가 기록되어 충족 처리됨';
            }
        }
        return criterion?.score_reason || '';
    }

    public domainScore(domain: any) {
        return (domain?.criteria || []).reduce((total: number, criterion: any) => total + this.criterionScore(criterion), 0);
    }

    private calculatedBreakdown() {
        const followup = this.activeFollowup || this.selectedFollowup();
        if (!followup) return { ptsd: 0, positive: 0, safety: 0, total: 0 };
        if (this.safetyStopActive()) {
            return {
                ptsd: Number(followup.ptsd_score || 0),
                positive: Number(followup.positive_memory_score || 0),
                safety: Number((followup.domains || []).find((domain: any) => domain.id === 'safety_differential')?.score || 0),
                total: Number(followup.current_score || 0)
            };
        }
        const domains = followup.domains || [];
        const ptsd = domains
            .filter((domain: any) => domain.group === 'ptsd')
            .reduce((total: number, domain: any) => total + this.domainScore(domain), 0);
        const positive = domains
            .filter((domain: any) => domain.group === 'positive')
            .reduce((total: number, domain: any) => total + this.domainScore(domain), 0);
        const safety = this.domainScore(domains.find((domain: any) => domain.id === 'safety_differential'));
        return { ptsd, positive, safety, total: ptsd + positive };
    }

    public drawerScore() {
        return this.calculatedBreakdown().total;
    }

    public drawerPtsdScore() {
        return this.calculatedBreakdown().ptsd;
    }

    public drawerPositiveScore() {
        return this.calculatedBreakdown().positive;
    }

    public remainingCriteriaCount() {
        const domains = this.activeFollowup?.domains || [];
        return domains.reduce((total: number, domain: any) => total + (domain.criteria || [])
            .filter((criterion: any) => this.criterionScore(criterion) < Number(criterion.max_score)).length, 0);
    }

    public safetyStopActive() {
        return this.activeFollowup?.completion?.safety_review_required === true
            || (this.activeFollowup?.questions || []).some((question: any) =>
            question.risk_if_present
            && this.questionState(question).status === 'present'
            && String(this.questionState(question).note || '').trim().length > 0
        );
    }

    public scoreReady() {
        const score = this.calculatedBreakdown();
        return !this.safetyStopActive()
            && score.total >= Number(this.activeFollowup?.target_score || 85)
            && score.ptsd >= 55
            && score.positive >= 22
            && score.safety >= 6;
    }

    public reevaluateFollowup() {
        const followup = this.activeFollowup || this.selectedFollowup();
        if (!followup) return;
        if (this.isMediaGenerationFollowup(followup)) {
            const notesRequired = (followup.questions || [])
                .filter((question: any) => this.questionNeedsAnswerNote(question)).length;
            if (notesRequired > 0) {
                this.reevaluationMessage = `선택한 답변 ${notesRequired}개에 생성 반영 내용이 없습니다. 반영할 내용을 기록하거나 건너뛰기를 선택해 주세요.`;
                void this.service.render();
                return;
            }
            if (this.generationReadinessDefinition()) {
                const score = this.generationReadinessScore();
                const target = this.generationReadinessTarget();
                if (this.generationConsentDenied()) {
                    this.reevaluationMessage = '환자가 이미지·영상 제작에 동의하지 않아 생성 단계로 진행하지 않습니다.';
                } else if (!this.generationConsentGranted()) {
                    this.reevaluationMessage = `생성 준비도 ${score}점입니다. 이미지·영상 제작 동의를 먼저 확인해야 합니다.`;
                } else if (this.missingRequiredGenerationQuestions().length > 0) {
                    const labels = this.missingRequiredGenerationQuestions()
                        .filter((question: any) => question.gate_id !== 'generation_consent')
                        .map((question: any) => question.domain)
                        .join(' · ');
                    this.reevaluationMessage = `생성 준비도 ${score}점입니다. ${labels || '필수 정보'} 확인 후 다시 분석해 주세요.`;
                } else if (this.generationReady()) {
                    this.reevaluationMessage = `생성 준비도 ${score}점으로 목표 ${target}점을 충족했습니다. 의료진 검토 후 이미지·영상 생성 단계로 진행할 수 있습니다.`;
                } else {
                    this.reevaluationMessage = `생성 준비도 ${score}점입니다. 목표 ${target}점까지 컷 구성 보완 질문을 확인해 주세요.`;
                }
                void this.service.render();
                return;
            }
            const answered = this.answeredQuestionCount();
            const deferred = (followup.questions || [])
                .filter((question: any) => this.questionState(question).status === 'deferred').length;
            this.reevaluationMessage = `추가 답변 ${answered}개를 기록했습니다${deferred ? ` · 건너뛰기 ${deferred}개` : ''}. 확인되지 않은 장면은 만들어 넣지 않습니다.`;
            void this.service.render();
            return;
        }
        if (this.safetyStopActive()) {
            this.reevaluationMessage = '현재 위험 가능성이 기록되어 점수 계산을 중단했습니다. 나머지 문진보다 기관 위기대응·안전 확보 절차를 우선해 주세요.';
            void this.service.render();
            return;
        }
        const notesRequired = (followup.questions || []).filter((question: any) => this.questionNeedsAnswerNote(question)).length;
        if (notesRequired > 0) {
            this.reevaluationMessage = `선택한 답변 ${notesRequired}개에 근거 메모가 없습니다. 명시적 답변을 기록해야 해당 원자 기준의 점수가 충족됩니다.`;
            void this.service.render();
            return;
        }
        const score = this.drawerScore();
        const breakdown = this.calculatedBreakdown();
        const remaining = this.remainingCriteriaCount();
        if (this.scoreReady()) {
            this.reevaluationMessage = `임시 충분도 ${score}점(PTSD ${breakdown.ptsd}/70 · 행복 기억 ${breakdown.positive}/30)으로 사용 기준을 충족했습니다. 의료진의 답변 적절성 검토 후 확정해 주세요.`;
        } else {
            const totalGap = Math.max(0, Number(followup.target_score) - score);
            const ptsdGap = Math.max(0, 55 - breakdown.ptsd);
            const positiveGap = Math.max(0, 22 - breakdown.positive);
            const safetyGap = Math.max(0, 6 - breakdown.safety);
            this.reevaluationMessage = `임시 충분도 ${score}점입니다. 총점 부족 ${totalGap}점 · PTSD 기준 부족 ${ptsdGap}점 · 행복 기억 기준 부족 ${positiveGap}점 · 안전 기준 부족 ${safetyGap}점이며, 미충족 원자 기준은 ${remaining}개입니다.`;
        }
        void this.service.render();
    }

    public rawDesignNotes() {
        const notes = this.selectedScenario?.design_notes || {};
        return [
            { label: '말하기 방식', value: notes.speaking_style, icon: 'fa-comment-dots' },
            { label: '핵심 반응', value: notes.core_response, icon: 'fa-wave-square' },
            { label: '좋은 기억 흐름', value: notes.positive_memory_flow, icon: 'fa-sun' },
            { label: '의료진 드라이빙', value: notes.clinician_direction, icon: 'fa-user-doctor' }
        ].filter((item: any) => !!item.value);
    }

    public extractionGroups(memoryKind: 'trauma' | 'positive') {
        const rows = this.selectedScenario?.element_extraction?.[memoryKind];
        return Array.isArray(rows) ? rows : [];
    }

    public evidenceTurnLabel(group: any) {
        const turns = Array.isArray(group?.evidence_turns)
            ? group.evidence_turns.filter((turn: any) => Number(turn) > 0)
            : [];
        return turns.length ? `${turns.join('·')}번 환자 발화` : '환자 발화 근거';
    }

    public selectPromptMedia(bundleKey: string, mediaKey: string) {
        this.selectedPromptMedia = { ...this.selectedPromptMedia, [bundleKey]: mediaKey };
        void this.service.render();
    }

    public activePrompt(bundle: any) {
        const mediaKey = this.selectedPromptMedia[bundle?.key] || 'image';
        return bundle?.prompts?.[mediaKey] || null;
    }

    public avoidPrompt(prompt: any) {
        return String(prompt?.['negative_' + 'prompt'] || '');
    }

    public async copyPrompt(bundle: any) {
        const prompt = this.activePrompt(bundle);
        if (!prompt?.prompt) return;
        const value = `${prompt.prompt}\n\n제외 조건: ${this.avoidPrompt(prompt) || '없음'}`;
        let copied = false;
        try {
            if (navigator.clipboard?.writeText) {
                await navigator.clipboard.writeText(value);
                copied = true;
            }
        } catch (_error) {
            copied = false;
        }
        if (!copied) copied = this.copyWithFallback(value);
        this.copiedPromptKey = copied ? bundle.key : 'failed';
        await this.service.render();
        if (this.copyResetTimer) window.clearTimeout(this.copyResetTimer);
        this.copyResetTimer = window.setTimeout(async () => {
            this.copiedPromptKey = '';
            await this.service.render();
        }, 1800);
    }

    private copyWithFallback(value: string) {
        const input = document.createElement('textarea');
        input.value = value;
        input.setAttribute('readonly', '');
        input.style.position = 'fixed';
        input.style.left = '-9999px';
        input.style.opacity = '0';
        document.body.appendChild(input);
        input.select();
        input.setSelectionRange(0, input.value.length);
        try {
            return document.execCommand('copy');
        } catch (_error) {
            return false;
        } finally {
            document.body.removeChild(input);
        }
    }

    public isSelected(item: any) {
        return this.selectionKey(this.selectedScenario) === this.selectionKey(item);
    }

    public trackByScenario(_index: number, item: any) {
        return `${item?.source === 'raw' ? 'raw' : 'set'}:${item?.uploaded_id || item?.id || ''}`;
    }

    public trackByTurn(_index: number, item: any) {
        return `${item.phase}-${item.turn}`;
    }

    public trackByQuestion(_index: number, item: any) {
        return item?.id || _index;
    }

    private selectionKey(item: any) {
        if (!item) return '';
        return `${item.source === 'raw' ? 'raw' : 'set'}:${item.uploaded_id || item.id}`;
    }

    private readonly emptyQuestionState: any = { status: 'unanswered', note: '' };
}

export default PageScenarioSetsComponent;